const messages = {
  pt: {
    translations: {
      signup: {
        title: 'Crie sua conta',
        toasts: {
          success: 'Cadastro realizado com sucesso! Faça login para acessar o sistema.',
          fail: 'Erro ao criar usuário. Verifique os dados informados.',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          company: 'Nome da Empresa',
          phone: 'Whatsapp (DDD + NÚMERO)',
        },
        buttons: {
          submit: 'Cadastrar',
          login: 'Já tem uma conta? Entre!',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Senha',
          button: 'Acessar',
        },
        buttons: {
          submit: 'Entrar no Sistema',
          register: 'Cadastre-se agora!',
        },
      },
      companies: {
        title: 'Cadastrar Empresa',
        form: {
          name: 'Nome da Empresa',
          plan: 'Escolha o Plano',
          token: 'Token',
          submit: 'Cadastrar',
          success: 'Empresa criada com sucesso!',
        },
      },
      auth: {
        toasts: {
          success: 'Login efetuado com sucesso!',
        },
        dueDate: {
          expiration: 'Sua assinatura expira em',
          days: 'dias!',
          day: 'dia!',
          expirationToday: 'Sua assinatura expira hoje!',
        },
        token: 'Token',
      },
      dashboard: {
        tabs: {
          indicators: 'Indicadores',
          assessments: 'NPS',
          attendants: 'Atendentes',
        },
        charts: {
          perDay: {
            title: 'Atendimentos hoje: ',
          },
        },
        cards: {
          inAttendance: 'Em Atendimento',
          waiting: 'Aguardando',
          activeAttendants: 'Atendentes Ativos',
          finalized: 'Finalizados',
          newContacts: 'Novos Contatos',
          totalReceivedMessages: 'Mensagens Recebidas',
          totalSentMessages: 'Mensagens Enviadas',
          averageServiceTime: 'T.M. de Atendimento',
          averageWaitingTime: 'T.M. de Espera',
          status: 'Status (Atual)',
          activeTickets: 'Tickets Ativos',
          passiveTickets: 'Tickets Passivos',
          groups: 'Grupos',
        },
        users: {
          name: 'Nome',
          numberAppointments: 'Quantidade de Atendimentos',
          statusNow: 'Atual',
          totalCallsUser: 'Total de atendimentos por usuario',
          totalAttendances: 'TOTAL DE ATENDIMENTOS POR PERÍODO',
        },
        date: {
          initialDate: 'Data Inicial',
          finalDate: 'Data Final',
        },
        licence: {
          available: 'Disponível até',
        },
        assessments: {
          totalCalls: 'Total de Atendimentos',
          callsWaitRating: 'Atendimentos aguardando avaliação',
          callsWithoutRating: 'Atendimentos sem avaliação',
          ratedCalls: 'Atendimentos avaliados',
          evaluationIndex: 'Índice de avaliação',
          score: 'Pontuação',
          prosecutors: 'Promotores',
          neutral: 'Neutros',
          detractors: 'Detratores',
        },
      },
      reportsSurvey: {
        title: 'Relatório de Pesquisas Realizadas',
        operator: 'Operador',
        period: 'Período',
        until: 'Até',
        date: 'Data',
        reportTitle: 'Relatórios',
        calls: 'Atendimentos',
        search: 'Pesquisas',
        durationCalls: 'Duracão dos atendimentos',
        grupoSessions: 'Atendimentos em grupos',
        groupTicketsReports: {
          timezone: 'America/Sao_Paulo',
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          errorToast: 'Erro ao gerar o relatório',
          back: 'Voltar',
          groupServiceReport: 'Relatório de Atendimento em Grupos',
          loading: 'Carregando...',
          contact: 'Contato',
          dateOpen: 'Data abertura',
          dateLastUpdated: 'Data Última Atualização',
          agent: 'Quem atendeu',
          agentClosed: 'Quem fechou',
          waitingAssistance: 'Aguardando atendimento',
          process: 'Em atendimento',
        },
        researchReports: {
          response: 'resposta',
          active: '(Ativa)',
          inactive: '(Inativa)',
          quantity: 'Quantidade',
          percentage: 'porcentagem',
          title: 'Relatório de Pesquisas Realizadas',
          activeSearch: 'Pesquisa ativa',
          inactiveSearch: 'Pesquisa inativa',
        },
        ticketDurationDetail: {
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          title: 'Relatório de Duração do Atendimento',
          startService: 'Início do atendimento',
          lastUpdated: 'Última atualização',
          lastAgent: 'Último atendente',
          durationFinished: 'Duração após finalizado',
        },
        ticketDuration: {
          title: 'Relatório de Duração dos Atendimento',
          contact: 'Contato',
          open: 'Abertos',
          pending: 'Pendentes',
          finished: 'Finalizados',
          durationFinished: 'Duração dos finalizados',
          durationAfterFinished: 'Duração após finalizado',
          actions: 'Ações',
        },
        ticketReports: {
          msgToast: 'Gerando relatório compactado, por favor aguarde.',
          title: 'Relatório de Atendimento',
        },
        pdf: {
          title: 'Relação de Atendimentos Realizados',
          exportTitle: 'Relação de Atendimentos em Grupos Realizados',
        },
      },
      todo: {
        newTask: 'Nova Tarefa',
        add: 'Adicionar',
        task: 'Tarefas',
      },
      contactImportWpModal: {
        title: 'Exportar Contatos para o Excel',
        exportSuccess: 'Exportação concluída com sucesso!',
        buttons: {
          downloadModel: 'Download modelo do excel para importação',
          closed: 'Fechar',
          import: 'Selecione o arquivo do excel para importar Contatos',
        },
      },
      connections: {
        title: 'Conexões',
        waitConnection: 'Aguarde... Suas conexões serão reiniciadas!',
        newConnection: 'Nova Conexão',
        restartConnections: 'Reiniciar Conexões',
        callSupport: 'Chamar Suporte',
        toasts: {
          deleted: 'Conexão excluída com sucesso!',
          disconnected: 'Conexão desconectada com sucesso!',
          closedimported: 'Estamos fechando os tickets importados, por favor aguarde uns instantes',
        },
        facebook: {
          success: 'Conexão Facebook/Instagram conectada com sucesso!',
          errorConfig: 'Configuração Facebook não disponível.',
          connecting: 'Conectando...',
          redirecting: 'Redirecionando...',
          errorRedirect: 'Erro. Redirecionando...',
          errorNoUserId: 'Não foi possível obter o ID do usuário.',
          popupBlocked: 'Popup bloqueado. Permita popups neste site e tente novamente.',
        },
        meta: {
          openAuth: 'Janela de autorização aberta. Conclua o fluxo.',
        },
        confirmationModal: {
          closedImportedTitle: 'Fechar tickets importados',
          closedImportedMessage: 'Se você confirmar todos os tickets importados serão fechados',
          deleteTitle: 'Deletar',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida.',
          disconnectTitle: 'Desconectar',
          disconnectMessage: 'Tem certeza? Você precisará ler o QR Code novamente.',
          disconnectMetaMessage:
            'Tem certeza? A integração com Facebook/Instagram será desconectada.',
        },
        buttons: {
          add: 'Adicionar Conexão',
          disconnect: 'desconectar',
          tryAgain: 'Tentar novamente',
          qrcode: 'QR CODE',
          newQr: 'Novo QR CODE',
          closedImported: 'Fechar todos os tickets Importados',
          preparing: 'Preparando mensagens para importação',
          importing: 'Importando Mensagens do WhatsApp',
          processed: 'Processado',
          in: 'de',
          connecting: 'Conectando',
        },
        typography: {
          processed: 'Processado',
          in: 'de',
          date: 'Data da mensagem',
        },
        toolTips: {
          disconnected: {
            title: 'Falha ao iniciar sessão do WhatsApp',
            content:
              'Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code',
            titleMeta: 'Falha na integração com Facebook/Instagram',
            contentMeta:
              'A conexão com o Facebook ou Instagram foi perdida. Clique em reconectar para reautorizar.',
          },
          qrcode: {
            title: 'Esperando leitura do QR Code',
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: 'Conexão estabelecida!',
          },
          timeout: {
            title: 'A conexão com o celular foi perdida',
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: 'Nome',
          status: 'Status',
          lastUpdate: 'Última atualização',
          default: 'Padrão',
          actions: 'Ações',
          session: 'Sessão',
          number: 'Número do Whatsapp',
        },
      },
      showTicketOpenModal: {
        title: {
          header: 'Atendimento Existente',
        },
        form: {
          message: 'Este contato já está em atendimento:',
          user: 'Atendente',
          queue: 'Fila',
          messageWait: 'Este contato já está aguardando atendimento. Veja na aba Aguardando!',
        },
      },
      showTicketLogModal: {
        title: {
          header: 'Histórico do ticket',
          subtitle: 'Linha do tempo do atendimento',
        },
        empty: 'Nenhum registro encontrado.',
        end: 'Início do histórico',
        system: 'Sistema',
        meta: {
          from: 'De',
          queue: 'Departamento',
          user: 'Atendente',
          reason: 'Motivo',
          comment: 'Observação',
          client: 'Cliente',
          tag: 'Tag',
          waited: 'Tempo de espera',
          opportunity: 'Oportunidade',
          pipeline: 'Funil',
          stage: 'Etapa',
          value: 'Valor',
          note: 'Nota',
        },
        options: {
          create: 'Ticket criado.',
          chatBot: 'ChatBot iniciado.',
          queue: ' - Fila definida.',
          open: ' iniciou o atendimento.',
          access: 'acessou o ticket.',
          transfered: 'transferiu o ticket.',
          receivedTransfer: 'recebeu o ticket transferido.',
          pending: 'devolveu a fila.',
          closed: 'fechou o ticket',
          reopen: 'reabriu o ticket',
          redirect: '- redirecionado',
          autoClose: 'fechado automaticamente.',
          userDefine: 'definiu o atendente.',
          nps: 'avaliação (NPS).',
          delete: 'excluiu o ticket.',
          retriesLimitQueue: 'limite de tentativas na fila.',
          retriesLimitUserDefine: 'limite de tentativas do atendente.',
          linkClient: 'vinculou um cliente.',
          tagAdded: 'adicionou uma tag.',
          tagRemoved: 'removeu uma tag.',
          leadValueChanged: 'alterou o valor do lead.',
          firstResponse: 'respondeu pela primeira vez.',
          opportunityLinked: 'criou uma oportunidade no CRM.',
          noteAdded: 'adicionou uma observação interna.',
        },
      },
      closeTicketReasonModal: {
        title: 'Encerrar atendimento',
        subtitle: 'Selecione o motivo do fechamento',
        reasonLabel: 'Motivo',
        reasonRequired: 'Selecione um motivo para encerrar',
        noReasons: 'Nenhum motivo cadastrado. Cadastre em Configurações.',
        commentLabel: 'Observação (opcional)',
        buttons: {
          cancel: 'Cancelar',
          confirm: 'Encerrar',
        },
      },
      whatsappModal: {
        title: {
          add: 'Adicionar Conexão',
          edit: 'Editar Conexão',
        },
        tabs: {
          general: 'Geral',
          messages: 'Mensagens',
          assessments: 'NPS',
          integrations: 'Integrações',
          schedules: 'Horário de expediente',
        },
        form: {
          importOldMessagesEnable: 'Importar mensagens do aparelho',
          importOldMessages: 'Data de inicio da importação',
          importRecentMessages: 'Data de termino da importação',
          closedTicketsPostImported: 'Encerrar tickets após importação',
          name: 'Nome',
          queueRedirection: 'Redirecionamento de Fila',
          queueRedirectionDesc:
            'Selecione uma fila para os contatos que não possuem fila serem redirecionados',
          default: 'Padrão',
          group: 'Permitir grupos',
          timeSendQueue: 'Tempo em minutos para redirecionar para fila',
          importAlert:
            'ATENÇÃO: Ao salvar, sua conexão será encerrada, será necessário ler novamente o QR Code para importar as mensagens',
          importMax30Days: 'O período de importação não pode exceder 30 dias',
          importMax30DaysHint: 'Máximo 30 dias entre as datas',
          allowGroup: 'Permitir grupos',
          groupAsTicket: 'Tratar grupos como ticket',
          maxUseBotQueues: 'Enviar bot x vezes',
          timeUseBotQueues: 'Enviar bot em x minutos',
          expiresTicket: 'Encerrar chats abertos após x minutos',
          expiresTicketNPS: 'Encerrar chats aguardando avaliação após x minutos',
          maxUseBotQueuesNPS: 'Quantidade máxima de vezes que a avaliaçao vai ser enviada',
          closeLastMessageOptions1: 'Do atendente/Cliente',
          closeLastMessageOptions2: 'Do atendente',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          lgpdLinkPrivacy: 'Link para política de privacidade',
          lgpdMessage: 'Mensagem de saudaçao LGPD',
          lgpdDeletedMessages: 'Ofuscar mensagem apagada pelo contato',
          lgpdSendMessage: 'Sempre solicitar confirmação do contato',
          ratingMessage: 'Mensagem de avaliaçao - Escala deve ser de 0 a 10',
          token: 'Token para integração externa',
          sendIdQueue: 'Fila',
          inactiveMessage: 'Mensagem de inatividade',
          timeInactiveMessage: 'Tempo em minutos para envio do aviso de inatividade',
          whenExpiresTicket: 'Encerrar chats abertos quando última mensagem for',
          expiresInactiveMessage: 'Mensagem de encerramento por inatividade',
          prompt: 'Prompt',
          collectiveVacationEnd: 'Data final',
          collectiveVacationStart: 'Data inicial',
          collectiveVacationMessage: 'Mensagem de férias coletivas',
          queueIdImportMessages: 'Fila para importar as mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        menuItem: {
          enabled: 'Habilitado',
          disabled: 'Desabilitado',
          minutes: 'minutos',
        },
        success: 'Conexão salvo com sucesso.',
        errorSendQueue:
          'Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos',
        errorExpiresNPS:
          'Informe o tempo de encerramento dos chats aguardando avaliação — obrigatório pois a conexão está configurada para avaliar atendimentos.',
        errorRatingMessage:
          'É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.',
      },
      qrCode: {
        message: 'Leia o QrCode para iniciar a sessão',
      },
      contacts: {
        title: 'Contatos',
        toasts: {
          deleted: 'Contato excluído com sucesso!',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Deletar ',
          importTitlte: 'Importar contatos',
          exportContact: 'Exportar contatos',
          deleteMessage:
            'Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.',
          blockContact: 'Tem certeza que deseja bloquear este contato?',
          unblockContact: 'Tem certeza que deseja desbloquear este contato?',
          importMessage: 'Deseja importar todos os contatos do telefone?',
          importChat: 'Importar Conversas',
          wantImport: 'Deseja importar todas as conversas do telefone?',
        },
        buttons: {
          import: 'Importar Contatos',
          add: 'Novo contato',
          export: 'Exportar Contato',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          email: 'Email',
          actions: 'Ações',
          lastMessage: 'Última Mensagem',
        },
        menu: {
          importYourPhone: 'Importar do aparelho padrão',
          importToExcel: 'Importar / Exportar do Excel',
        },
      },
      forwardMessage: {
        text: 'Encaminhada',
      },
      forwardMessageModal: {
        title: 'Encaminhar mensagem',
        buttons: {
          ok: 'Encaminhar',
        },
      },
      promptModal: {
        form: {
          name: 'Nome',
          prompt: 'Prompt',
          voice: 'Voz',
          max_tokens: 'Máximo de Tokens na resposta',
          temperature: 'Temperatura',
          apikey: 'API Key',
          max_messages: 'Máximo de mensagens no Histórico',
          voiceKey: 'Chave da API de Voz',
          voiceRegion: 'Região de Voz',
        },
        success: 'Agente IA salvo com sucesso!',
        title: {
          add: 'Adicionar agente IA',
          edit: 'Editar agente IA',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          save: 'Salvar agente',
        },
        subtitle: 'Configure seu agente em poucos passos e publique com seguranca.',
        tabs: {
          start: 'Inicio',
          tools: 'Ferramentas',
          knowledge: 'Conhecimento',
        },
        sections: {
          agentName: 'Nome do agente',
          serviceQueue: 'Setor de atendimento',
          mainPrompt: 'Prompt principal',
          aiConfig: 'Configuração de IA',
          tools: 'Ferramentas disponíveis para este agente IA',
          knowledge: 'Base de conhecimento',
        },
        quickStart: {
          title: 'Inicio rapido',
          description: 'Comece pelo basico para publicar seu agente sem confusao.',
          step1: 'Defina nome e setor',
          step2: 'Escreva o prompt principal',
          step3: 'Escolha modelo de IA',
        },
        hints: {
          agentName: 'Escolha um nome curto e facil de identificar.',
          serviceQueue: 'Defina em qual fila esse agente vai atuar (obrigatorio).',
          mainPrompt: 'Escreva o comportamento do agente, tom de voz e limites de resposta.',
          aiConfigByok: 'Escolha o provedor, modelo e configure o acesso de IA para esse agente.',
          aiConfigPlatform:
            'Escolha o provedor e modelo de IA. Os créditos do plano serão usados automaticamente.',
          noProvider:
            'Nenhum provedor de IA configurado. Solicite ao administrador que configure as chaves de API na seção de Créditos de IA.',
          platformCredits: 'Este agente usará créditos do plano para processar as respostas de IA.',
          tools:
            'Marque somente as ferramentas que este agente deve usar. Funções sensíveis (ex.: integrações externas ou criação de empresa) ficam desabilitadas até você ativar explicitamente.',
          knowledge:
            'Envie PDFs, imagens ou cadastre links para fornecer contexto adicional à IA. Esses materiais serão usados para enriquecer as respostas do agente.',
        },
        aiProvider: {
          label: 'Provedor de IA',
          model: 'Modelo',
          mode: 'Modo de uso de IA',
          modeAuto: 'Automático',
          modeByok: 'Minha chave API',
          modePlatform: 'Créditos do plano',
          modeAutoDesc: 'Usa chave própria se disponível, senão créditos do plano',
          modeByokDesc: 'Usa somente a chave configurada neste agente',
          modePlatformDesc: 'Usa somente créditos da plataforma, ignora chave própria',
          freeLabel: 'Grátis',
        },
        tools: {
          sensitive: 'Sensível',
          active: 'Ativa para este agente',
          inactive: 'Desativada',
        },
        knowledge: {
          addImage: 'Adicionar imagem',
          uploading: 'Enviando...',
          selectImage: 'Selecionar imagem',
          addLink: 'Adicionar link',
          linkTitle: 'Título do link',
          linkUrl: 'URL (https://...)',
          addButton: 'Adicionar',
          resources: 'Recursos adicionados',
          empty:
            'Nenhum conteúdo cadastrado ainda. Adicione arquivos ou links para disponibilizar conhecimento à IA.',
          defaultTitle: 'Link salvo',
          imageLabel: 'Imagem',
          linkLabel: 'Link',
          open: 'Abrir',
          copyLink: 'Copiar link',
          remove: 'Remover',
        },
        validation: {
          queueRequired: 'Selecione o setor de atendimento',
          promptRequired: 'Informe o prompt principal',
          apiKeyRequired: 'Informe a API Key',
          providerRequired: 'Selecione o provedor de IA',
          providerUnavailable: 'Provedor não disponível — chave de API não configurada',
          modelRequired: 'Selecione o modelo de IA',
        },
        toasts: {
          linkCopied: 'Link copiado!',
          copyError: 'Não foi possível copiar o link.',
          uploadError: 'Não foi possível enviar o arquivo.',
          fileAdded: 'Arquivo adicionado à base de conhecimento!',
          linkTitleRequired: 'Informe o título e o link.',
          invalidUrl: 'Informe um link válido (https://...).',
          linkAdded: 'Link adicionado à base de conhecimento!',
        },
      },
      prompts: {
        title: 'Agentes IA',
        table: {
          name: 'Nome',
          queue: 'Setor/Fila',
          max_tokens: 'Máximo Tokens Resposta',
          actions: 'Ações',
          agent: 'Agente',
          sector: 'Setor',
          maxTokens: 'Max tokens',
          tools: 'Ferramentas',
          noTools: 'Nenhuma',
          noQueue: 'Sem fila',
          edit: 'Editar',
          editAgent: 'Editar agente',
          delete: 'Excluir',
          deleteAgent: 'Excluir agente',
        },
        page: {
          title: 'Agentes de IA',
          subtitle: 'Configure agentes inteligentes para responder clientes',
          search: 'Buscar agente IA...',
          addButton: 'Novo agente',
          addTooltip: 'Adicionar agente IA',
          agentCount_one: 'agente IA configurado',
          agentCount_other: 'agentes IA configurados',
          expandedAriaLabel: 'Detalhes do agente {{name}}',
          rowsPerPage: 'Linhas:',
          displayedRows: '{{from}}-{{to}} de {{count}}',
        },
        messages: {
          noOpenAiPermission:
            'Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.',
        },
        expandedPanel: {
          sections: {
            agentAndSector: 'Agente e setor',
            modelAndParams: 'Modelo e parâmetros',
            mainPrompt: 'Prompt principal',
            toolsAndKnowledge: 'Ferramentas e conhecimento',
            keysHidden: 'Chaves (ocultas)',
            tokenUsage: 'Uso de tokens',
            registry: 'Registro',
          },
          fields: {
            id: 'ID',
            name: 'Nome',
            companyId: 'Empresa (ID)',
            sector: 'Setor',
            queueId: 'Fila (ID)',
            provider: 'Provedor',
            model: 'Modelo',
            temperature: 'Temperatura',
            maxTokens: 'Max. tokens',
            maxMessages: 'Max. mensagens',
            voice: 'Voz',
            text: 'Texto',
            activeTools: 'Ferramentas ativas',
            kbItems: 'Itens na base',
            apiKey: 'API (IA)',
            voiceKey: 'Voz (key)',
            voiceRegion: 'Região voz',
            promptTokens: 'Prompt',
            completionTokens: 'Conclusão',
            totalTokens: 'Total',
            createdAt: 'Criado em',
            updatedAt: 'Atualizado em',
          },
          yes: 'Sim',
          no: 'Não',
          none: 'Nenhuma',
          notConfigured: 'Não configurada',
          hiddenShort: '•••••••• (oculto)',
          hiddenPartial: '{{start}}…{{end}} (oculto)',
          providers: {
            openai: 'OpenAI',
            gemini: 'Google Gemini',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida!',
        },
        buttons: {
          add: 'Adicionar agente IA',
        },
      },
      iaWorkflow: {
        page: {
          title: 'Workflow de IA',
          subtitle: 'Configure a IA orquestradora e conecte agentes especializados',
        },
        sections: {
          data: 'Dados do workflow',
          orchestrator: 'Agente IA orquestrador',
          agents: 'Agentes conectados',
        },
        form: {
          name: 'Nome do workflow',
          nameHelp: 'Ex.: Atendimento SDR, Suporte N2',
          description: 'Descrição',
          orchestratorHint: 'Selecione o agente IA que será o cérebro/orquestrador:',
          agentAlias: 'Apelido do agente',
          agentAliasHelp: 'Nome exibido na execução do workflow',
          selectAgentIa: 'Selecionar agente IA',
          searchAgent: 'Buscar agente',
          searchAgentIa: 'Buscar agente IA',
        },
        buttons: {
          addAgent: 'Adicionar agente',
          saveWorkflow: 'Salvar workflow',
          saving: 'Salvando...',
          close: 'Fechar',
          cancel: 'Cancelar',
          saveChanges: 'Salvar alterações',
        },
        modal: {
          editTitle: 'Editar agente',
          addTitle: 'Adicionar agente',
          subtitle: 'Configure o agente e selecione um agente IA',
        },
        messages: {
          noAgents: 'Nenhum agente adicionado ainda.',
          loading: 'Carregando workflow de IA...',
          saveSuccess: 'Workflow salvo com sucesso',
          noPermission: 'Você não tem permissão para acessar este editor.',
        },
        validation: {
          nameRequired: 'Informe um nome para o workflow.',
          nameMinLength: 'Use pelo menos 3 caracteres no nome.',
          orchestratorRequired: 'Selecione um agente IA orquestrador.',
          agentsRequired: 'Adicione pelo menos um agente ao workflow.',
          agentsDuplicate: 'Existem agentes duplicados com o mesmo agente IA e apelido.',
          agentIaRequired: 'Selecione um agente IA.',
          agentAliasRequired: 'Informe um apelido para o agente.',
          agentAliasExists: 'Já existe um agente com esse agente IA e apelido.',
        },
      },
      contactModal: {
        title: {
          add: 'Adicionar contato',
          edit: 'Editar contato',
        },
        form: {
          mainInfo: 'Dados do contato',
          extraInfo: 'Informações adicionais',
          name: 'Nome',
          number: 'Número do Whatsapp',
          email: 'Email',
          extraName: 'Nome do campo',
          extraValue: 'Valor',
          chatBotContact: 'Desabilitar chatbot',
          termsLGDP: 'Termos LGPD aceito em:',
          whatsapp: 'Conexão Origem: ',
        },
        buttons: {
          addExtraInfo: 'Adicionar informação',
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Contato salvo com sucesso.',
      },
      flowbuilderModal: {
        flowNotIdPhrase: 'Fluxo padrão',
      },
      queueModal: {
        title: {
          queueData: 'Dados da fila',
          text: 'Horários de atendimento',
          add: 'Adicionar fila',
          edit: 'Editar fila',
          confirmationDelete: 'Tem certeza? Todas as opções de integrações serão deletadas.',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          orderQueue: 'Ordem da fila (Bot)',
          rotate: 'Rodízio',
          timeRotate: 'Tempo de Rodízio',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          token: 'Token',
          integrationId: 'Integração',
          fileListId: 'Lista de arquivos',
          closeTicket: 'Fechar ticket',
          queueType: 'Tipo de menu',
          message: 'Mensagem de retorno',
          queue: 'Fila para transferência',
          integration: 'Integração',
          file: 'Lista de arquivos',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        bot: {
          title: 'Opções',
          toolTipTitle: 'Adicione opções para construir um chatbot',
          toolTip:
            'Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante',
          selectOption: 'Selecione uma opção',
          text: 'Texto',
          attendent: 'Atendente',
          queue: 'Fila',
          integration: 'Integração',
          file: 'Arquivo',
          toolTipMessageTitle: 'A mensagem é obrigatória para seguir ao próximo nível',
          toolTipMessageContent: 'A mensagem é obrigatória para seguir ao próximo nível',
          selectUser: 'Selecione um Usuário',
          selectQueue: 'Selecione uma Fila',
          selectIntegration: 'Selecione uma Integração',
          addOptions: 'Adicionar opções',
        },
        serviceHours: {
          dayWeek: 'Dia da semana',
          startTimeA: 'Hora Inicial - Turno A',
          endTimeA: 'Hora Final - Turno A',
          startTimeB: 'Hora Inicial - Turno B',
          endTimeB: 'Hora Final - Turno B',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Adicionar projeto',
          edit: 'Editar projeto',
        },
        form: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Tempo em minutos para expirar uma conversa',
          typebotKeywordFinish: 'Palavra para finalizar o ticket',
          typebotKeywordRestart: 'Palavra para reiniciar o fluxo',
          typebotRestartMessage: 'Mensagem ao reiniciar a conversa',
          typebotUnknownMessage: 'Mensagem de opção inválida',
          typebotDelayMessage: 'Intervalo (ms) entre mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          test: 'Testar Bot',
        },
        messages: {
          testSuccess: 'Integração testada com sucesso!',
          addSuccess: 'Integração adicionada com sucesso.',
          editSuccess: 'Integração editada com sucesso.',
        },
      },
      userModal: {
        warning: 'Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!',
        title: {
          add: 'Adicionar usuário',
          edit: 'Editar usuário',
          myProfile: 'Meu perfil',
          updateImage: 'Atualizar imagem',
          removeImage: 'Excluir imagem',
        },
        myProfileSubtitle: 'Dados gerais, filas e configurações da sua conta.',
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          farewellMessage: 'Mensagem de despedida',
          profile: 'Perfil',
          profileUser: 'Usuário',
          profileAdmin: 'Administrador',
          profileOwner: 'Proprietário',
          profileSuperAdmin: 'Super Admin',
          startWork: 'Inicio de trabalho',
          endWork: 'Fim de trabalho',
          whatsapp: 'Conexão Padrão',
          allTicketEnable: 'Habilitado',
          allTicketDisable: 'Desabilitado',
          allTicket: 'Visualizar chamados sem fila',
          allowGroup: 'Permitir Grupos',
          defaultMenuOpen: 'Aberto',
          defaultMenuClosed: 'Fechado',
          defaultMenu: 'Menu padrão',
          allHistoric: 'Ver conversas de outras filas',
          allHistoricEnabled: 'Habilitado',
          allHistoricDisabled: 'Desabilitado',
          allUserChat: 'Ver conversas de outros usuários',
          userClosePendingTicket: 'Permitir fechar tickets pendentes',
          showDashboard: 'Ver Dashboard',
          allowRealTime: 'Ver Painel de Atendimentos',
          allowConnections: 'Permitir ações nas conexões',
        },
        tabs: {
          general: 'Geral',
          permissions: 'Permissões',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          addImage: 'Adicionar Imagem',
          editImage: 'Editar Imagem',
        },
        success: 'Usuário salvo com sucesso.',
        permissionsSaveError: 'Usuário salvo, mas houve um erro ao salvar as permissões de acesso.',
      },
      companyModal: {
        title: {
          add: 'Adicionar empresa',
          edit: 'Editar empresa',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          passwordDefault: 'Senha',
          numberAttendants: 'Usuários',
          numberConections: 'Conexões',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Empresa salvo com sucesso.',
      },
      scheduleModal: {
        title: {
          add: 'Novo Agendamento',
          edit: 'Editar Agendamento',
        },
        form: {
          body: 'Mensagem',
          contact: 'Contato',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          assinar: 'Enviar Assinatura',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          close: 'Fechar',
          addSchedule: 'Adicionar agendamento',
        },
        success: 'Agendamento salvo com sucesso.',
        confirmationModal: {
          deleteTitle: 'Excluir anexo',
          deleteMessage: 'Tem certeza que deseja excluir este anexo?',
        },
        toasts: {
          deleted: 'Anexo excluído com sucesso.',
        },
      },
      contactTagPicker: {
        title: 'Adicionar tag',
        subtitle: 'Clique para selecionar ou remover',
        searchPlaceholder: 'Buscar tag...',
        close: 'Fechar',
        empty: 'Nenhuma tag encontrada',
        emptyNoTags: 'Você ainda não tem etiquetas cadastradas.',
        emptyNoTagsHint: 'Crie etiquetas para organizar e filtrar seus contatos.',
        emptySearch: 'Nenhuma etiqueta corresponde à sua busca.',
        createTags: 'Criar etiquetas',
      },
      tagModal: {
        title: {
          add: 'Nova Tag',
          edit: 'Editar Tag',
          addKanban: 'Novo Quadro',
          editKanban: 'Editar Quadro',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
          timeLane: 'Horas até redirecionar',
          timeLaneHelper:
            'Após esse intervalo (em horas), o ticket pode ser movido para o quadro de destino ao lado.',
          nextLaneId: 'Quadro de destino',
          greetingMessageLane: 'Mensagem de saudação',
          greetingMessageLaneHelper: 'Texto exibido no contexto deste quadro no Kanban.',
          rollbackLaneId: 'Quadro ao retomar',
          rollbackLaneHelper:
            'Quadro para o qual o ticket retorna quando o atendimento for retomado.',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Tag salva com sucesso.',
        successKanban: 'Quadro salvo com sucesso.',
      },
      fileModal: {
        title: {
          add: 'Adicionar lista de arquivos',
          edit: 'Editar lista de arquivos',
        },
        buttons: {
          okAdd: 'Salvar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
          fileOptions: 'Adicionar arquivo',
        },
        form: {
          name: 'Nome da lista de arquivos',
          message: 'Detalhes da lista',
          fileOptions: 'Lista de arquivos',
          extraName: 'Mensagem para enviar com arquivo',
          extraValue: 'Valor da opção',
        },
        success: 'Lista de arquivos salva com sucesso!',
      },
      chat: {
        noTicketMessage: 'Selecione um ticket para começar a conversar.',
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: '⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️',
          titleFileList: 'Lista de arquivo(s)',
        },
      },
      chatInternal: {
        new: 'Novo Chat Interno',
        widget: {
          hubKicker: 'Chat empresa',
          hubHeadline: 'Olá! Em que podemos ajudar?',
          hubSubline: 'Costumamos responder em poucos minutos.',
          searchPlaceholder: 'Buscar conversas…',
          emptyList: 'Nenhuma conversa encontrada.',
          emptyThread: 'Nenhuma mensagem ainda. Envie a primeira.',
          newConversation: 'Nova conversa',
          typeMessage: 'Digite uma mensagem…',
        },
        header: {
          back: 'Voltar à lista',
          subtitle: 'Criado por {{name}} · ',
          subtitleOwnerOnly: 'Criado por {{name}}',
          subtitleDateOnly: 'Criado em ',
        },
        media: {
          attach: 'Anexar arquivo (uma mídia por envio)',
          recordAudio: 'Gravar áudio',
          recordStop: 'Parar gravação',
          recordCancel: 'Cancelar gravação',
          recordConfirm: 'Enviar áudio gravado',
          send: 'Enviar mensagem',
          recordError: 'Não foi possível usar o microfone. Verifique a permissão do navegador.',
          recordUnsupported: 'Seu navegador não suporta gravação de áudio aqui.',
          recordingPlaceholder: 'Gravando áudio…',
          attachmentPreview: {
            title: 'Anexo',
            remove: 'Remover',
            send: 'Enviar',
            imageAlt: 'Pré-visualização da imagem',
            videoLabel: 'Pré-visualização do vídeo',
            audioHint: 'Arquivo de áudio',
            fileHint: 'Pré-visualização não disponível para este tipo de arquivo',
          },
        },
        modal: {
          conversation: 'Conversa',
          title: 'Título',
          titleRequired: 'Informe um título para a conversa.',
          filterUsers: 'Filtro por Usuários',
          cancel: 'Fechar',
          save: 'Salvar',
        },
        modalDelete: {
          title: 'Excluir Conversa',
          message: 'Esta ação não pode ser revertida, confirmar?',
        },
        deleteMessage: 'Excluir mensagem',
        deleteMessageConfirm: 'Excluir esta mensagem para todos? Esta ação não pode ser desfeita.',
        deleteModal: {
          title: 'Excluir mensagem',
          question: 'Tem certeza que deseja excluir esta mensagem?',
          subtext: 'Esta ação não pode ser desfeita.',
          confirm: 'Excluir',
          cancel: 'Cancelar',
          previewAudio: 'Áudio',
          previewImage: 'Foto',
          previewVideo: 'Vídeo',
          previewDocument: 'Documento',
        },
      },
      ticketsManager: {
        questionCloseTicket: 'VOCÊ DESEJA FECHAR TODOS OS TICKETS?',
        yes: 'SIM',
        not: 'NÃO',
        buttons: {
          newTicket: 'Novo',
          resolveAll: 'Resolver Todos',
          close: 'Fechar',
          new: 'Novo',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Filas',
      },
      tickets: {
        inbox: {
          closedAllTickets: 'Fechar todos os tickets?',
          closedAll: 'Fechar Todos',
          newTicket: 'Novo Ticket',
          yes: 'SIM',
          no: 'NÃO',
          open: 'Abertos',
          resolverd: 'Resolvidos',
        },
        toasts: {
          deleted: 'O atendimento que você estava foi deletado.',
        },
        notification: {
          message: 'Mensagem de',
        },
        tabs: {
          open: { title: 'Abertas' },
          closed: { title: 'Resolvidos' },
          search: { title: 'Busca' },
        },
        search: {
          placeholder: 'Buscar atendimento e mensagens',
          filterConections: 'Filtro por Conexão',
          filterConectionsOptions: {
            open: 'Aberto',
            closed: 'Fechado',
            pending: 'Pendente',
          },
          filterUsers: 'Filtro por Usuarios',
          filterContacts: 'Filtro por Contatos',
          ticketsPerPage: 'Tickets por página',
        },
        buttons: {
          showAll: 'Todos',
          returnQueue: 'Devolver a Fila',
          scredule: 'Agendamento',
          deleteTicket: 'Deletar Ticket',
          quickmessageflash: 'Mensagem Rápida',
        },
        closedTicket: {
          closedMessage: 'Fechar Ticket Com Mensagem de Despedida',
          closedNotMessage: 'Fechar Ticket Sem Mensagem de Despedida',
        },
        confirmationModal: {
          deleteTitle: 'Excluir ticket',
          deleteMessage: 'Deseja realmente excluir este ticket?',
          closeTitle: 'Fechar ticket',
          closeMessage: 'Deseja realmente fechar este ticket?',
          ignoreTitle: 'Ignorar ticket',
          ignoreMessage: 'Deseja realmente ignorar este ticket?',
        },
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        subtitle: 'Escolha o atendente (opcional) e o departamento de destino.',
        close: 'Fechar',
        fieldLabel: 'Digite para buscar usuários',
        fieldQueueLabel: 'Departamento (fila)',
        fieldQueuePlaceholder: 'Selecione um departamento (fila)',
        fieldWhatsapp: 'Selecione um whatsapp',
        noOptions: 'Nenhum usuário encontrado com esse nome',
        msgTransfer: 'Observações - mensagem interna, não vai para o cliente',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar',
        },
      },
      ticketsList: {
        called: 'Chamado',
        today: 'Hoje',
        missedCall: 'Chamada de voz/vídeo perdida às',
        pendingHeader: 'Aguardando',
        assignedHeader: 'Atendendo',
        groupingHeader: 'Grupos',
        noTicketsTitle: 'Nenhum ticket encontrado',
        noTicketsMessage:
          'Nenhum ticket encontrado nesta aba com os filtros ou termo de busca atuais.',
        noQueue: 'Sem Fila',
        buttons: {
          accept: 'Aceitar',
          cancel: 'Cancelar',
          start: 'iniciar',
          closed: 'Fechar',
          reopen: 'Reabrir',
          transfer: 'Transferir',
          ignore: 'Ignorar',
          exportAsPDF: 'Exportar para PDF',
          kanbanActions: 'Opções de Kanban',
        },
        acceptModal: {
          title: 'Aceitar Chat',
          queue: 'Departamento (fila)',
        },
      },
      newTicketModal: {
        title: 'Criar Ticket',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      SendContactModal: {
        title: 'Enviar contato',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        buttons: {
          ok: 'Enviar',
          cancel: 'Cancelar',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          connections: 'Conexões',
          chatsTempoReal: 'Painel',
          tickets: 'Atendimentos',
          quickMessages: 'Respostas rápidas',
          contacts: 'Contatos',
          queues: 'Departamentos (fila)',
          tags: 'Tags',
          administration: 'Administração',
          companies: 'Empresas',
          users: 'Usuários',
          settings: 'Configurações',
          files: 'Lista de arquivos',
          helps: 'Ajuda',
          messagesAPI: 'API',
          schedules: 'Agendamentos',
          campaigns: 'Campanhas',
          annoucements: 'Informativos',
          chats: 'Chat Interno',
          financeiro: 'Financeiro',
          queueIntegration: 'Integrações',
          version: 'Versão',
          kanban: 'Kanban',
          prompts: 'Agende IA',
          allConnections: 'Gerenciar conexões',
          reports: 'Relatórios',
          management: 'Gerência',
        },
        appBar: {
          user: {
            profile: 'Perfil',
            logout: 'Sair',
            message: 'Olá',
            messageEnd: 'seja bem-vindo a',
            active: 'Ativo até',
            goodMorning: 'Oi,',
            myName: 'meu nome é',
            continuity: 'e darei continuidade em seu atendimento.',
            virtualAssistant: 'Assistente Virtual',
            token: 'Token inválido, por favor entre em contato com o administrador da plataforma.',
          },
          message: {
            location: 'Localização',
            contact: 'Contato',
          },
          notRegister: 'Nenhum registro',
          refresh: 'Atualizar',
        },
      },
      languages: {
        undefined: 'Idioma',
        'pt-BR': 'Português',
        es: 'Español',
        en: 'English',
      },
      messagesAPI: {
        title: 'API',
        textMessage: {
          number: 'Número',
          body: 'Mensagem',
          token: 'Token cadastrado',
          userId: 'ID do usuário/atendente',
          queueId: 'ID da Fila',
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nome do arquivo',
          media: 'Arquivo',
          token: 'Token cadastrado',
        },
        API: {
          title: 'Documentação para envio de mensagens',
          methods: {
            title: 'Métodos de Envío',
            messagesText: 'Mensagens de Texto',
            messagesMidia: 'Mensagens com Arquivos',
          },
          instructions: {
            title: 'Instruções',
            comments: 'Observações Importantes',
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              'O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:',
            codeCountry: 'Código do País',
            code: 'DDD',
            number: 'Número',
          },
          text: {
            title: '1. Mensagens de Texto',
            instructions:
              'Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:',
          },
          media: {
            title: '2. Mensagens com Arquivo',
            instructions:
              'Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:',
          },
        },
      },
      notifications: {
        noTickets: 'Nenhuma notificação.',
      },
      runFlow: {
        title: 'Executar fluxo',
        searchPlaceholder: 'Buscar fluxo…',
        empty: 'Nenhum fluxo ativo disponível',
        noMatch: 'Nenhum fluxo encontrado',
        toasts: {
          success: 'Fluxo disparado',
        },
        errors: {
          forbidden: 'Você não tem permissão para executar fluxos',
        },
        buttons: {
          execute: 'Executar',
          executing: 'Executando…',
          cancel: 'Cancelar',
        },
      },
      quickMessages: {
        title: 'Respostas Rápidas',
        searchPlaceholder: 'Pesquisar...',
        noAttachment: 'Sem anexo',
        pickerEmpty: 'Nenhuma mensagem rápida cadastrada.',
        noTextPreview: '(sem texto)',
        confirmationModal: {
          deleteTitle: 'Exclusão',
          deleteMessage: 'Esta ação é irreversível! Deseja prosseguir?',
        },
        buttons: {
          add: 'Adicionar',
          attach: 'Arquivo',
          cancel: 'Cancelar',
          edit: 'Editar',
        },
        toasts: {
          success: 'Atalho adicionado com sucesso!',
          deleted: 'Atalho removido com sucesso!',
        },
        dialog: {
          title: 'Mensagem Rápida',
          shortcode: 'Atalho',
          message: 'Resposta',
          save: 'Salvar',
          cancel: 'Cancelar',
          geral: 'Edição por outros',
          add: 'Adicionar',
          edit: 'Editar',
          visao: 'Visível para o time',
          sharingSectionTitle: 'Compartilhamento',
          sharingSectionHint:
            'Defina quem pode usar esta resposta no atendimento e quem pode alterá-la.',
          visaoHelper: 'Ativo: outros atendentes veem e podem inserir esta resposta nas conversas.',
          visaoOptionYes: 'Sim, compartilhar com o time',
          visaoOptionNo: 'Não, apenas eu',
          geralHelper:
            'Ativo: qualquer usuário com acesso pode editar o texto e o atalho. Inativo: só o criador edita.',
          geralHelperDisabled: 'Disponível quando a resposta estiver visível para o time.',
          geralOptionYes: 'Sim, qualquer um pode editar',
          geralOptionNo: 'Não, só o criador edita',
          subtitle: 'Crie atalhos de mensagem para o time.',
          insertEmoji: 'Inserir emoji',
          removeAttachment: 'Remover arquivo',
        },
        table: {
          shortcode: 'Atalho',
          message: 'Mensagem',
          actions: 'Ações',
          mediaName: 'Nome do Arquivo',
          status: 'Status',
          editable: 'Editar',
          viewOnly: 'Somente visualização',
        },
      },
      contactLists: {
        title: 'Listas segmentadas (tags)',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova lista de contatos',
        },
        dialog: {
          name: 'Nome',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          deleted: 'Registro excluído',
          updated: 'Lista atualizada.',
          created: 'Lista criada.',
        },
      },
      contactListItems: {
        title: 'Contatos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo',
          lists: 'Listas',
          import: 'Importar',
        },
        dialog: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        table: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
          importMessage: 'Deseja importar os contatos desta planilha? ',
          importTitlte: 'Importar',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },

      kanban: {
        title: 'Kanban',
        searchPlaceholder: 'Pesquisa',
        subMenus: {
          list: 'Painel',
          tags: 'Quadros',
        },
      },

      campaigns: {
        title: 'Campanhas',
        massDispatchTitle: 'Disparo em massa',
        searchPlaceholder: 'Pesquisa',
        subMenus: {
          list: 'Listagem',
          listContacts: 'Lista de contatos',
          settings: 'Configurações',
        },
        settings: {
          randomInterval: 'Intervalo Randômico de Disparo',
          noBreak: 'Sem Intervalo',
          intervalGapAfter: 'Intervalo maior após',
          undefined: 'Não definido',
          messages: 'mensagens',
          laggerTriggerRange: 'Intervalo de disparo maior',
          addVar: 'Adicionar variável',
          save: 'Salvar',
          close: 'Fechar',
          add: 'Adicionar',
          shortcut: 'Atalho',
          content: 'Conteúdo',
        },
        buttons: {
          add: 'Nova campanha',
          addPhrase: 'Nova campanha por frase',
          contactLists: 'Listas de Contatos',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          contactList: 'Lista de Contatos',
          option: 'Nenhuma',
          disabled: 'Desabilitada',
          enabled: 'Habilitada',
          status: 'Status',
          scheduledAt: 'Agendamento',
          completedAt: 'Concluída',
          confirmation: 'Confirmação',
          actions: 'Ações',
        },
        dialog: {
          new: 'Nova Campanha',
          update: 'Editar Campanha',
          readonly: 'Apenas Visualização',
          help: 'Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.',
          modalSubtitleNew: 'Configure o disparo em massa e visualize a prévia no celular.',
          modalSubtitleEdit: 'Ajuste mensagens, público-alvo, conexões e agendamento.',
          form: {
            name: 'Nome',
            message1: 'Mensagem 1',
            message2: 'Mensagem 2',
            message3: 'Mensagem 3',
            message4: 'Mensagem 4',
            message5: 'Mensagem 5',
            confirmationMessage1: 'Mensagem de Confirmação 1',
            confirmationMessage2: 'Mensagem de Confirmação 2',
            confirmationMessage3: 'Mensagem de Confirmação 3',
            confirmationMessage4: 'Mensagem de Confirmação 4',
            confirmationMessage5: 'Mensagem de Confirmação 5',
            messagePlaceholder: 'Conteúdo da mensagem',
            whatsapp: 'Conexão',
            status: 'Status',
            scheduledAt: 'Agendamento',
            confirmation: 'Confirmação',
            contactList: 'Lista de Contato',
            tagList: 'Contatos por tag',
            targetAudience: 'Público-alvo',
            targetAudienceHelp:
              'Escolha uma lista de contatos existente ou selecione uma tag para gerar a lista com os contatos vinculados a ela. São exibidas apenas tags que possuem contatos.',
            statusTicket: 'Status do Ticket',
            openTicketStatus: 'Aberto',
            pendingTicketStatus: 'Pendente',
            closedTicketStatus: 'Fechado',
            enabledOpenTicket: 'Habilitado',
            disabledOpenTicket: 'Desabilitado',
            openTicket: 'Abrir ticket',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Disparos',
            restart: 'Reiniciar Disparos',
            close: 'Fechar',
            attach: 'Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          cancel: 'Campanha cancelada',
          restart: 'Campanha reiniciada',
          deleted: 'Registro excluído',
        },
      },
      campaignReport: {
        title: 'Relatório de Campanha',
        back: 'Voltar',
        inactive: 'Inativa',
        scheduled: 'Programada',
        process: 'Em Andamento',
        cancelled: 'Cancelada',
        finished: 'Finalizada',
        campaign: 'Campanha',
        validContacts: 'Contatos Válidos',
        confirmationsRequested: 'Confirmações Solicitadas',
        confirmations: 'Confirmações',
        deliver: 'Entregues',
        connection: 'Conexão',
        contactLists: 'Lista de Contatos',
        schedule: 'Agendamento',
        conclusion: 'Conclusão',
      },
      announcements: {
        title: 'Informativos',
        searchPlaceholder: 'Pesquisa',
        active: 'Ativo',
        inactive: 'Inativo',
        buttons: {
          add: 'Informativo',
          contactLists: 'Listas de Informativos',
        },
        table: {
          priority: 'Prioridade',
          title: 'Title',
          text: 'Texto',
          mediaName: 'Arquivo',
          status: 'Status',
          actions: 'Ações',
        },
        dialog: {
          edit: 'Edição de Informativo',
          add: 'Informativo',
          update: 'Editar Informativo',
          readonly: 'Apenas Visualização',
          form: {
            priority: 'Prioridade',
            title: 'Title',
            text: 'Texto',
            mediaPath: 'Arquivo',
            status: 'Status',
            high: 'Alta',
            medium: 'Média',
            low: 'Baixa',
            active: 'Ativo',
            inactive: 'Inativo',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Fechar',
            attach: 'Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          deleted: 'Registro excluído',
        },
      },
      campaignsConfig: {
        title: 'Configurações de Campanhas',
      },
      queues: {
        title: 'Departamentos',
        table: {
          name: 'Nome',
          color: 'Cor',
          greeting: 'Mensagem de saudação',
          orderQueue: 'Ordenação da fila (bot)',
          actions: 'Ações',
          ID: 'ID',
        },
        buttons: {
          add: 'Adicionar fila',
        },
        toasts: {
          success: 'Fila salva com sucesso',
          deleted: 'Fila exclu[ida com sucesso',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.',
        },
      },
      queue: {
        queueData: 'Dados',
      },
      queueSelect: {
        inputLabel: 'Departamento (fila)',
        inputLabelRO: 'Filas somente leitura',
        withoutQueue: 'Sem fila',
      },
      reports: {
        title: 'Relatórios de Atendimentos',
        table: {
          id: 'Ticket',
          user: 'Usuário',
          dateOpen: 'Data Abertura',
          dateClose: 'Data Fechamento',
          NPS: 'NPS',
          status: 'Status',
          whatsapp: 'Conexão',
          queue: 'Fila',
          actions: 'Ações',
          lastMessage: 'Últ. Mensagem',
          contact: 'Cliente',
          supportTime: 'Tempo de Atendimento',
        },
        buttons: {
          filter: 'Filtrar',
          onlyRated: 'Apenas Avaliados',
        },
        searchPlaceholder: 'Pesquisar...',
      },
      queueIntegration: {
        title: 'Integrações',
        table: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          lastUpdate: 'Ultima atualização',
          actions: 'Ações',
        },
        buttons: {
          add: 'Adicionar Projeto',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas',
        },
      },
      users: {
        title: 'Usuários',
        table: {
          status: 'Status',
          name: 'Nome',
          email: 'Email',
          profile: 'Perfil',
          profiles: {
            admin: 'Administrador',
            user: 'Usuário',
            owner: 'Proprietário',
            superAdmin: 'Super Admin',
          },
          startWork: 'Inicio de trabalho',
          endWork: 'Fim de trabalho',
          actions: 'Ações',
          ID: 'ID',
        },
        buttons: {
          add: 'Adicionar usuário',
        },
        toasts: {
          deleted: 'Usuário excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.',
        },
      },
      compaies: {
        title: 'Empresas',
        table: {
          ID: 'ID',
          status: 'Ativo',
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          phone: 'Telefone',
          plan: 'Plano',
          active: 'Ativo',
          numberAttendants: 'Atendentes',
          numberConections: 'Conexões',
          value: 'Valor',
          namePlan: 'Nome Plano',
          numberQueues: 'Filas',
          useCampaigns: 'Campanhas',
          useSchedules: 'Mensagens agendadas',
          useInternalChat: 'Chat Interno',
          useFacebook: 'Facebook',
          useInstagram: 'Instagram',
          useWhatsappOfficial: 'Whatsapp Oficial',
          useOpenAi: 'Agentes de IA',
          useTasks: 'Tarefas',
          useProducts: 'Produtos',
          useIntegrations: 'Integrações',
          useClients: 'Clientes',
          createdAt: 'Criada Em',
          dueDate: 'Vencimento',
          lastLogin: 'Ult. Login',
          actions: 'Ações',
          money: 'R$',
          noPlan: 'Sem plano',
          yes: 'Sim',
          no: 'Não',
          document: 'CNPJ/CPF',
          recurrence: 'Recorrência',
          monthly: 'Mensal',
          bimonthly: 'Bimestral',
          quarterly: 'Trimestral',
          semester: 'Semestral',
          yearly: 'Anual',
          clear: 'Limpar',
          delete: 'Excluir',
          user: 'Usuário',
          save: 'Salvar',
        },
        buttons: {
          add: 'Adicionar empresa',
        },
        toasts: {
          deleted: 'Empresa excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.',
        },
      },
      plans: {
        form: {
          name: 'Nome',
          users: 'Usuários',
          connections: 'Conexões',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          enabled: 'Habilitadas',
          disabled: 'Desabilitadas',
          clear: 'Cancelar',
          delete: 'Excluir',
          save: 'Salvar',
          yes: 'Sim',
          no: 'Não',
          money: 'R$',
          public: 'Público',
          planName: 'Nome do plano',
          visibility: 'Visibilidade',
          recurrence: 'Recorrência',
          publicOption: 'Público',
          privateOption: 'Privado',
          queues: 'Filas',
          amount: 'Valor',
          allowByok: 'Permitir chave própria (BYOK)',
          allowPlatformCredits: 'Permitir créditos da plataforma',
          includedCredits: 'Créditos de IA incluídos por período',
        },
        sections: {
          config: 'Configuração',
          limits: 'Limites e valor',
          resources: 'Recursos disponíveis',
          ai: 'Inteligência Artificial',
        },
        grid: {
          empty: 'Nenhum plano cadastrado',
          emptyHelp: 'Clique em "Novo plano" para começar',
          users: 'usuários',
          connections: 'conexões',
          queues: 'filas',
          byok: 'BYOK',
          editBtn: 'Editar plano',
          viewBtn: 'Ver plano',
          system: 'Padrão sistema',
          publicTag: 'Público',
          privateTag: 'Privado',
        },
        messages: {
          systemPlanTitle: 'Plano padrão do sistema',
          systemPlanWarning:
            'Este plano não pode ser editado nem excluído. Crie um plano novo para ofertas personalizadas.',
          addTitle: 'Novo plano',
          readonlyTitle: 'Plano (somente leitura)',
          editTitle: 'Editar plano',
          loadError: 'Não foi possível carregar a lista de registros',
          systemLocked: 'Este plano é padrão do sistema e não pode ser alterado.',
          success: 'Operação realizada com sucesso!',
          minCharge: 'Valor mínimo da cobrança em BRL não atingido. Ajuste o valor do plano.',
          operationError:
            'Não foi possível realizar a operação. Verifique se já existe um plano com o mesmo nome ou se os campos foram preenchidos corretamente',
          deleteSystemPlan: 'Este plano é padrão do sistema e não pode ser excluído.',
          deletePlanDefault: 'O plano padrão não pode ser excluído.',
          hasCompanies: 'Este plano possui empresas vinculadas e não pode ser excluído.',
          hasInvoices: 'Este plano possui faturas vinculadas e não pode ser excluído.',
          deleteFailed: 'Não foi possível realizar a operação',
        },
        modal: {
          deleteTitle: 'Exclusão de Registro',
          deleteConfirm: 'Deseja realmente excluir esse registro?',
          addNew: 'Novo plano',
        },
      },
      helps: {
        title: 'Central de Ajuda',
        settings: {
          codeVideo: 'Código do Video',
          description: 'Descrição',
          clear: 'Limpar',
          delete: 'Excluir',
          save: 'Salvar',
        },
      },
      schedules: {
        title: 'Agendamentos',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Agendamento?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          contact: 'Contato',
          body: 'Mensagem',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          status: 'Status',
          actions: 'Ações',
        },
        buttons: {
          add: 'Novo Agendamento',
        },
        toasts: {
          deleted: 'Agendamento excluído com sucesso.',
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tag?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          id: 'ID',
          name: 'Nome',
          kanban: 'Kanban',
          color: 'Cor',
          tickets: 'Registros Tags',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Tag',
        },
        toasts: {
          deleted: 'Tag excluído com sucesso.',
        },
      },

      tagsKanban: {
        title: 'Quadros',
        laneDefault: 'Em aberto',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Quadro?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Tickets',
          actions: 'Ações',
        },
        buttons: {
          add: 'Novo Quadro',
        },
        toasts: {
          deleted: 'Quadro excluído com sucesso.',
        },
      },

      files: {
        title: 'Lista de arquivos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ação',
        },
        toasts: {
          deleted: 'Lista excluída com sucesso!',
          deletedAll: 'Todas as listas foram excluídas com sucesso!',
        },
        buttons: {
          add: 'Adicionar',
          deleteAll: 'Deletar Todos',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteAllTitle: 'Deletar Todos',
          deleteMessage: 'Tem certeza que deseja deletar esta lista?',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as listas?',
        },
      },
      settings: {
        success: 'Configurações salvas com sucesso.',
        title: 'Configurações',
        tabs: {
          options: 'Opções',
          plans: 'Planos',
          helps: 'Ajuda',
        },
        settings: {
          userCreation: {
            name: 'Criação de usuário',
            options: {
              enabled: 'Ativado',
              disabled: 'Desativado',
            },
          },
          tabs: {
            options: 'Opções',
            schedules: 'Horários',
            plans: 'Planos',
            help: 'Ajuda',
          },
          options: {
            disabled: 'Desabilitado',
            enabled: 'Habilitado',
            updating: 'Atualizando...',
            creationCompanyUser: 'Criação de Empresa/Usuário',
            evaluations: 'Avaliações',
            officeScheduling: 'Agendamento de Expediente',
            queueManagement: 'Gerenciamento por Fila',
            companyManagement: 'Gerenciamento por Empresa',
            connectionManagement: 'Gerenciamento por Conexão',
            sendGreetingAccepted: 'Enviar saudação ao aceitar o ticket',
            sendMsgTransfTicket: 'Enviar mensagem transferência de setor/atendente',
            checkMsgIsGroup: 'Ignorar Mensagens de Grupos',
            chatBotType: 'Tipo do Bot',
            userRandom: 'Escolher atendente aleatório',
            buttons: 'Botões',
            acceptCallWhatsapp: 'Informar que não aceita ligação no whatsapp?',
            sendSignMessage: 'Permite atendente escolher ENVIAR Assinatura',
            sendGreetingMessageOneQueues: 'Enviar saudação quando houver somente 1 fila',
            sendQueuePosition: 'Enviar mensagem com a posição da fila',
            sendFarewellWaitingTicket: 'Enviar mensagem de despedida no Aguardando',
            acceptAudioMessageContact: 'Aceita receber audio de todos contatos?',
            enableLGPD: 'Habilitar tratamento LGPD',
            requiredTag: 'Tag obrigatoria para fechar ticket',
            closeTicketOnTransfer: 'Fechar ticket ao transferir para outra fila',
            DirectTicketsToWallets: 'Mover automaticamente cliente para carteira',
            showNotificationPending: 'Mostrar notificação para tickets pendentes',
          },
          customMessages: {
            sendQueuePositionMessage: 'Mensagem de posição na fila',
            AcceptCallWhatsappMessage: 'Mensagem para informar que não aceita ligações',
            greetingAcceptedMessage: 'Mensagem de Saudação ao aceitar ticket',
            transferMessage: 'Mensagem de transferência - ${queue.name} = fila destino',
          },
          LGPD: {
            title: 'LGPD',
            welcome: 'Mensagem de boas vindas(LGPD)',
            linkLGPD: 'Link da política de privacidade',
            obfuscateMessageDelete: 'Ofuscar mensagem apagada',
            alwaysConsent: 'Sempre solicitar consentimento',
            obfuscatePhoneUser: 'Ofuscar número telefone para usuários',
            enabled: 'Habilitado',
            disabled: 'Desabilitado',
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Atribuído à:',
          dialogRatingTitle: 'Deseja deixar uma avaliação de atendimento para o cliente?',
          dialogClosingTitle: 'Finalizando o atendimento com o cliente!',
          dialogRatingCancel: 'Com Mensagem de Despedida',
          dialogRatingSuccess: 'Resolver e Enviar Avaliação',
          dialogRatingWithoutFarewellMsg: 'SEM Mensagem de Despedida',
          ratingTitle: 'Escolha um menu de avaliação',
          notMessage: 'Nenhuma mensagem selecionada',
          amount: 'Valor de prospecção',
          buttons: {
            return: 'Retornar',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceitar',
            rating: 'Enviar Avaliação',
            enableIntegration: 'Habilitar integração',
            disableIntegration: 'Desabilitar integração',
            logTicket: 'Logs do Ticket',
            requiredTag: 'Você deve atribuir uma tag antes de fechar o ticket.',
          },
        },
        reactionPicker: {
          moreEmojis: 'Mais emojis',
        },
        reactionDetail: {
          titleOne: '1 reação',
          titleMany: '{{count}} reações',
          you: 'Você',
          clickToRemove: 'Clique para remover',
          removeMyReaction: 'Remover minha reação',
          removeSessionFooterHint:
            'Use o link abaixo para remover a reação feita por esta conexão WhatsApp no painel.',
          badgeHint: 'Ver reações',
        },
      },
      messagesInput: {
        placeholderPrivateMessage: 'Digite uma mensagem ou aperte / para respostas rápidas',
        placeholderOpen: 'Digite uma mensagem ou aperte / para respostas rápidas',
        placeholderClosed: 'Reabra ou aceite esse ticket para enviar uma mensagem.',
        signMessage: 'Assinar',
        privateMessage: 'Mensagem Privada',
      },
      contactDrawer: {
        header: 'Dados do contato',
        buttons: {
          edit: 'Editar contato',
          block: 'Bloquear',
          unblock: 'Desbloquear',
        },
        extraInfo: 'Outras informações',
      },
      messageVariablesPicker: {
        label: 'Variáveis disponíveis',
        vars: {
          contactFirstName: 'Primeiro Nome',
          contactName: 'Nome',
          user: 'Atendente',
          greeting: 'Saudação',
          protocolNumber: 'Protocolo',
          date: 'Data',
          hour: 'Hora',
          ticket_id: 'Nº do Chamado',
          queue: 'Setor',
          connection: 'Conexão',
          invoiceDueDate: 'Vencimento da fatura',
          invoiceValue: 'Valor da fatura',
        },
      },
      ticketOptionsMenu: {
        schedule: 'Agendamento',
        delete: 'Deletar',
        transfer: 'Transferir',
        registerAppointment: 'Observações do Contato',
        resolveWithNoFarewell: 'Finalizar sem despedida',
        acceptAudioMessage: 'Aceitar áudios do contato?',
        appointmentsModal: {
          title: 'Observações do Ticket',
          textarea: 'Observação',
          placeholder: 'Insira aqui a informação que deseja registrar',
        },
        confirmationModal: {
          title: 'Deletar o ticket do contato',
          titleFrom: 'do contato ',
          message: 'Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.',
        },
        buttons: {
          delete: 'Excluir',
          cancel: 'Cancelar',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Confirmar',
          cancel: 'Cancelar',
        },
      },
      messageInput: {
        tooltip: {
          signature: 'Habilitar/Desabilitar Assinatura',
          privateMessage: 'Habilitar/Desabilitar Mensagem Privada',
          meet: 'Enviar link para videoconferencia',
        },
        type: {
          attachFile: 'Anexar arquivo',
          imageVideo: 'Fotos e vídeos',
          cam: 'Câmera',
          document: 'Documento',
          contact: 'Contato',
          meet: 'Vídeo chamada',
          privateMessage: 'Mensagem privada',
          scheduleMessage: 'Agendamento de mensagem',
          moreOptions: 'Mais opções',
          moreOptionsDetail: 'Mais opções (botões, lista, etc.)',
          quickMessages: 'Mensagens rápidas',
          signature: 'Assinatura (nome do atendente)',
          emojis: 'Emojis',
        },
      },
      messageOptionsMenu: {
        delete: 'Deletar',
        reply: 'Responder',
        edit: 'Editar',
        forward: 'Encaminhar',
        toForward: 'Encaminhar',
        talkTo: 'Conversar Com',
        copyMessage: 'Copiar mensagem',
        copySuccess: 'Mensagem copiada!',
        copyNoText: 'Esta mensagem não contém texto para copiar.',
        confirmationModal: {
          title: 'Apagar mensagem?',
          message: 'Esta ação não pode ser revertida.',
        },
      },
      invoices: {
        table: {
          invoices: 'Faturas',
          details: 'Detalhes',
          users: 'Usuários',
          connections: 'Conexões',
          queue: 'Filas',
          value: 'Valor',
          expirationDate: 'Data Venc.',
          action: 'Ação',
        },
      },
      import: {
        page: {
          title: 'Importações',
          subtitle: 'Acompanhe as importações de histórico WhatsApp e Meta (Facebook/Instagram)',
        },
        buttons: {
          refresh: 'Atualizar',
          startMeta: 'Importar histórico (Meta)',
          backToConnections: 'Voltar às Conexões',
        },
        emptyState: 'Nenhuma importação encontrada',
        toasts: {
          started: 'Import iniciado',
          finished: 'Import finalizado',
        },
        metaModal: {
          title: 'Importar histórico (Meta)',
          hint: 'Se token estiver vazio, o backend usa o token salvo na conexão.',
          selectConnection: 'Selecione a conexão',
          selectConnectionRequired: 'Selecione uma conexão',
          loadingConnections: 'Carregando conexões...',
          noConnections: 'Nenhuma conexão Meta encontrada',
          pageIdRequired: 'Page ID é obrigatório',
          dateStart: 'Data início',
          dateEnd: 'Data fim',
        },
        banner: {
          importing: 'Importando histórico…',
          viewDetails: 'Ver detalhes',
        },
        tooltips: {
          whatsappAuto: 'WhatsApp importa automaticamente após conectar',
          metaRateLimit: 'Meta depende de permissões e rate limit',
        },
      },
      toastErrors: {
        generic: 'Não foi possível completar a operação. Tente novamente.',
        network: 'Falha de conexão. Verifique sua internet e tente novamente.',
        timeout: 'A requisição demorou demais. Tente novamente.',
        serverError: 'Erro no servidor ({{status}}). Tente novamente em instantes.',
        notFound: 'Recurso não encontrado. Verifique os dados e tente novamente.',
        forbidden: 'Você não tem permissão para realizar esta ação.',
        noPermissionToCreateContact:
          'Você não tem permissão para criar contatos. Solicite ao administrador para iniciar um atendimento com este contato.',
        httpError: 'Não foi possível completar a operação (erro {{status}}). Tente novamente.',
        noPagePermission: 'Esta empresa não possui permissão para acessar essa página!',
        whatsappIdInput: 'Informe o Whatsapp ID.',
        fileTooLarge5mb: 'Arquivo é muito grande! 5MB máximo',
        selectQueue: 'Selecione uma fila',
        selectFlow: 'Selecione um fluxo',
        ticketIdInput: 'Informe o Ticket ID.',
        enterMessageText: 'Digite o texto da mensagem',
        addAtLeastOneTag: 'Adicione pelo menos uma tag',
        selectKanbanTag: 'Selecione uma tag kanban',
        invoiceIdInput: 'Informe o Fatura ID.',
        userIdInput: 'Informe o User ID.',
        couldNotLoadRecords: 'Não foi possível carregar a lista de registros',
        invalidCpfCnpj: 'CPF/CNPJ inválido. Verifique o número informado.',
        errorUpdatingQueue: 'Erro ao atualizar fila.',
        fileTooLarge20mb: 'Arquivo é muito grande! 20MB máximo',
        errorLoadingData: 'Erro ao carregar dados',
        enterScheduleDateTime: 'Informe a data e o horário do agendamento.',
        dateTimeMustBeFuture: 'A data e o horário devem ser no futuro.',
        delayMin1Minute: 'O delay deve ser de pelo menos 1 minuto.',
        couldNotPerformOperation: 'Não foi possível realizar a operação',
        invalidPrimaryColor: 'Cor primária inválida. Use o formato HEX (#RGB ou #RRGGBB).',
        invalidColors: 'Existem cores inválidas. Use o formato HEX (#RGB ou #RRGGBB).',
        jsonInvalidQueueIds: 'JSON inválido em queueIds',
        tagIdToSearch: 'Informe o Tag ID para buscar um registro.',
        companyNotIdentified:
          'Empresa não identificada. Faça login novamente ou selecione uma empresa.',
        sourceAlreadyExists: 'Esta origem já existe.',
        selectAtLeastOneTicket: 'Selecione pelo menos um ticket',
        selectTagInContacts: 'Selecione a tag (nos contatos)',
        enterTokenBeforeDownload: 'Informe o token antes de baixar a coleção.',
        invalidFlow: 'Fluxo inválido.',
        errorFetchingZip: 'Erro ao consultar CEP. Tente novamente.',
        nameRequiredArticle: 'O nome é obrigatório.',
        invalidEmail: 'Email inválido.',
        invalidCpf: 'CPF inválido.',
        invalidCnpj: 'CNPJ inválido.',
        enterNewPassword: 'Informe a nova senha.',
        passwordsDoNotMatch: 'As senhas não conferem.',
        companyCannotBeDeleted: 'Esta empresa não pode ser excluída.',
        couldNotSaveValue: 'Não foi possível salvar o valor.',
        fileExceeds20mb: 'Arquivo excede o limite de 20 MB',
        selectClient: 'Selecione um cliente.',
        enterInvoiceDescription: 'Informe a descrição da fatura.',
        enterInvoiceValue: 'Informe o valor da fatura.',
        enterDueDate: 'Informe a data de vencimento.',
        selectReferenceItem: 'Selecione o item referente ou limpe o tipo de referência.',
        errorSendingFile: 'Erro ao enviar arquivo. Tente novamente.',
        selectFile: 'Selecione um arquivo!',
        selectKanbanTagAlt: 'Selecione uma tag do Kanban',
        selectTag: 'Selecione uma tag',
        invalidHeadersJson: 'Headers JSON inválido',
        invalidBodyJson: 'Body JSON inválido',
        errorTestingApi: 'Erro ao testar API',
        enterRequestUrl: 'Informe a URL da requisição',
        addValidCondition: 'Adicione pelo menos uma condição válida',
        selectPipeline: 'Selecione um pipeline',
        selectStage: 'Selecione uma etapa',
        enterTitle: 'Informe um título',
        selectTargetStage: 'Selecione a etapa destino',
        enterLossReason: 'Informe o motivo da perda',
        errorStartingAuth: 'Erro ao iniciar autenticação',
        enterSpreadsheetId: 'Informe o ID da planilha',
        errorTestingConnection: 'Erro ao testar conexão',
        selectSpreadsheet: 'Selecione uma planilha',
        enterSheetName: 'Informe o nome da aba',
        addDataField: 'Adicione pelo menos um campo de dados',
        enterColumnAndValue: 'Informe a coluna e valor para busca',
        enterIntervalValue: 'Adicione o valor de intervalo (mínimo 1 segundo)',
        percentAboveZero: 'Defina um percentual acima de 0%',
        percentMax100: 'O percentual máximo é 100%',
        errorFetchingQueues: 'Erro ao buscar filas',
        selectWhatsappConnection: 'Selecione uma conexão WhatsApp',
        enterMessage: 'Digite a mensagem',
        invalidNumber: 'Número inválido. Use código do país + DDD + número (ex: 5585999999999)',
        errorReadingMessage: 'Erro ao ler mensagem. Feche e reabra o modal.',
        emptyMessageFields: 'Campos de mensagem vazio!',
        errorReadingInterval: 'Erro ao ler intervalo. Feche e reabra o modal.',
        intervalRange: 'Intervalo não pode ser 0 ou maior que 120!',
        deleteEmptyCards: 'Delete os cards vazios (Imagem, Arquivo, Audio e Video)',
        verifyTokenEmpty: 'O verify token não pode estar vazio.',
        folderNameRequired: 'O nome da pasta é obrigatório.',
        enterPaymentValue: 'Informe o valor do pagamento.',
        tokenRequiredWhenProviderActive: 'Token é obrigatório quando o provider está ativo.',
        couldNotRemoveAccess: 'Não foi possível remover o acesso',
        minChargeNotReached:
          'Valor mínimo da cobrança em BRL não atingido. Ajuste o valor do plano.',
        defaultPlanCannotBeDeleted: 'O plano padrão não pode ser excluído.',
        planHasCompanies: 'Este plano possui empresas vinculadas e não pode ser excluído.',
        planHasInvoices: 'Este plano possui faturas vinculadas e não pode ser excluído.',
        couldNotLoadServices: 'Não foi possível carregar a lista de serviços',
        enterProfessionalName: 'Informe o nome do profissional',
        errorSavingProfessional: 'Erro ao salvar profissional',
        couldNotSendFile: 'Não foi possível enviar o arquivo.',
        enterTitleAndLink: 'Informe o título e o link.',
        enterValidLink: 'Informe um link válido (https://...).',
        errorSavingService: 'Erro ao salvar serviço',
        errorUploadingIcon: 'Erro ao fazer upload do ícone.',
        onlyImages: 'Envie apenas imagens (PNG, JPG, WebP ou ICO).',
        noAccessPermission: 'Sem permissão para acessar!',
        onlyP12Files: 'Use somente arquivos em formato p12!',
        errorSendingCertificate: 'Erro ao enviar certificado. Tente novamente.',
        errorSavingTheme: 'Erro ao salvar o tema.',
        errorSavingColors: 'Erro ao salvar personalização de cores.',
        errorSavingEmailFooter: 'Erro ao salvar configurações do rodapé de e-mail.',
        serverResponseNoFilename: 'Resposta do servidor sem nome do arquivo.',
        errorUploadingImage: 'Erro ao fazer upload da imagem.',
        couldNotSaveBanner: 'Não foi possível salvar o banner',
        couldNotLoadBanners: 'Não foi possível carregar os banners',
        couldNotRemoveBanner: 'Não foi possível remover o banner',
        invalidValue: 'Valor inválido.',
        urlNotConfigured: 'URL não configurada.',
        errorLinkingClient: 'Erro ao vincular cliente.',
        couldNotSaveAdditionalInfo: 'Não foi possível salvar as informações adicionais.',
        couldNotUpdateChatbot: 'Não foi possível atualizar o chatbot.',
        couldNotUpdateAudioPermission: 'Não foi possível atualizar a permissão de áudio.',
        couldNotChangeContactStatus: 'Não foi possível alterar o status do contato.',
        titleRequired: 'Título é obrigatório',
        videoUrlRequired: 'URL do vídeo é obrigatória',
        descriptionMax300: 'Descrição deve ter no máximo 300 caracteres',
        errorAccessingMic: 'Erro ao acessar o microfone. Verifique as permissões.',
        recordingTooShort: 'Gravação muito curta. Grave por mais tempo.',
        errorSendingAudio: 'Erro ao enviar áudio. Tente novamente.',
        errorProcessingAudio: 'Erro ao processar áudio.',
        errorCancellingRecording: 'Erro ao cancelar gravação.',
        invalidContactForSend: 'Contato inválido para envio. Verifique nome e número.',
        errorUpdatingHubToken: 'Houve um erro ao tentar atualizar o token do Hub.',
        clientIdToSearch: 'Informe o Client ID para buscar um registro.',
        nameRequiredDot: 'Nome é obrigatório.',
        contactIdToSearch: 'Informe o Contact ID para buscar um registro.',
        clientValueDueRequired: 'Cliente, valor e data de vencimento são obrigatórios.',
        invoiceIdRequired: 'Fatura ID é obrigatório.',
        queueIdToSearch: 'Informe o Queue ID para buscar um registro.',
        dealIdToSearch: 'Informe o Negócio ID para buscar um registro.',
        productIdToSearch: 'Informe o Product ID para buscar um registro.',
        serviceIdToSearch: 'Informe o Service ID para buscar um registro.',
        taskIdToSearch: 'Informe o Task ID para buscar.',
        jsonInvalidTagIds: 'JSON inválido em tagIds',
        userOrQueueToTransfer: 'Informe User ID ou Queue ID para transferir.',
        jsonInvalidServiceIds: 'JSON inválido em serviceIds',
        userIdToSearch: 'Informe o User ID para buscar.',
        userIdAndServiceIds: 'Informe User ID e serviceIds.',
        userIdAndDateTime: 'Informe User ID e Data/Hora.',
        userIdAppointmentStatus: 'Informe User ID, Compromisso ID e Status.',
        couldNotGetPaymentLink: 'Não foi possível recuperar o link de pagamento.',
        couldNotCloseTickets: 'Não foi possível encerrar os tickets. Tente novamente.',
        mustAcceptTerms: 'Você precisa aceitar os termos para continuar.',
        enterPipelineName: 'Informe o nome do funil',
        onlyOneWonStage: 'Apenas 1 estágio pode ser marcado como Ganho',
        onlyOneLostStage: 'Apenas 1 estágio pode ser marcado como Perdido',
        exportedFileEmpty: 'Erro: O arquivo exportado está vazio',
        selectFileToImport: 'Selecione um arquivo para importar',
        fileMustBeJson: 'O arquivo deve ser do tipo JSON',
        configureQueueNodes:
          'Configure a fila em todos os nós "Direcionar para Fila" antes de salvar.',
        emailNotFound: 'Email não encontrado',
        saveIntegrationBeforeMapping: 'Salve a integração antes de mapear campos.',
        invalidTestJson: 'JSON de teste inválido.',
        selectTicketStatus: 'Selecione pelo menos um status de ticket',
        selectWeekday: 'Selecione pelo menos um dia da semana',
        profileNotFound: 'Perfil não encontrado.',
        imageMax1mb: 'Imagem deve ter no máximo 1 MB',
        nameRequired: 'Nome é obrigatório',
        selectUser: 'Selecione um usuário',
        couldNotGetGoogleLink: 'Não foi possível obter o link de conexão com o Google.',
        allowPopups: 'Permita pop-ups neste site para conectar o Google Calendar.',
      },
      toastSuccess: {
        // genéricos
        operation: 'Operação realizada com sucesso!',
        operationUpdated: 'Operação atualizada com sucesso.',
        saved: 'Salvo com sucesso.',
        settingsSaved: 'Configurações salvas!',
        settingsSavedSuccess: 'Configurações salvas com sucesso!',
        settingsReset: 'Configurações resetadas com sucesso!',
        configSaved: 'Configuração salva com sucesso.',
        configRemoved: 'Configuração removida.',
        copied: 'Copiado!',
        linkCopied: 'Link copiado!',
        redirectUriCopied: 'Redirect URI copiada!',
        webhookUrlCopied: 'URL do webhook copiada!',
        clickSaveToApply: 'Clique em salvar para registrar as alterações.',
        exported: 'Dados exportados com sucesso!',
        testSuccess: 'Teste realizado com sucesso!',
        connectionTested: 'Conexão testada com sucesso!',
        // arquivos / mídia
        fileSent: 'Arquivo enviado com sucesso!',
        filesSent: 'Arquivos enviados com sucesso.',
        fileRemoved: 'Arquivo removido com sucesso.',
        fileUploaded: 'Arquivo enviado.',
        fileAdded: 'Arquivo adicionado com sucesso!',
        contentAdded: 'Conteúdo adicionado com sucesso!',
        audioAdded: 'Áudio adicionado com sucesso!',
        videoAdded: 'Vídeo adicionado com sucesso!',
        videoCreated: 'Vídeo criado com sucesso!',
        videoUpdated: 'Vídeo atualizado com sucesso!',
        videoRemoved: 'Vídeo removido com sucesso!',
        folderCreated: 'Pasta criada com sucesso!',
        folderUpdated: 'Pasta atualizada com sucesso!',
        folderDeleted: 'Pasta excluída com sucesso!',
        knowledgeFileAdded: 'Arquivo adicionado à base de conhecimento!',
        knowledgeLinkAdded: 'Link adicionado à base de conhecimento!',
        // compromissos / agenda
        appointmentCreated: 'Compromisso criado com sucesso.',
        appointmentUpdated: 'Compromisso atualizado com sucesso.',
        appointmentDeleted: 'Compromisso excluído com sucesso.',
        statusUpdated: 'Status atualizado.',
        scheduleCreated: 'Agenda criada com sucesso.',
        scheduleUpdated: 'Agenda atualizada com sucesso.',
        scheduleDeleted: 'Agenda excluída com sucesso.',
        googleCalendarLinked: 'Agenda vinculada ao seu Google Calendar com sucesso!',
        googleCalendarUnlinked: 'Google Calendar desvinculado da agenda.',
        googleCalendarDisconnected: 'Google Calendar desconectado com sucesso.',
        // tarefas / lixeira
        taskCreated: 'Tarefa criada com sucesso!',
        taskUpdated: 'Tarefa atualizada com sucesso!',
        taskRemoved: 'Tarefa removida.',
        taskRestored: 'Tarefa restaurada.',
        taskTrashed: 'Tarefa enviada para a lixeira.',
        taskDeletedPermanently: 'Tarefa excluída permanentemente.',
        opportunityRestored: '"{{title}}" restaurada com sucesso.',
        opportunityDeletedPermanently: 'Oportunidade excluída permanentemente.',
        // empresa / planos / apps
        companyCreated: 'Empresa cadastrada com sucesso!',
        planAccessRemoved: 'Acesso removido do plano.',
        appUpdated: 'App atualizado com sucesso.',
        appActivated: '{{app}} ativado.',
        appActivatedSuccess: '{{app}} ativado com sucesso!',
        appActivatedInvoicePaid: '{{app}} ativado — a fatura já estava paga.',
        appDeactivated: '{{app}} desativado.',
        appRequestCancelled: 'Solicitação de {{app}} cancelada.',
        paymentConfirmed: 'Pagamento confirmado.',
        appPaymentConfirmed: 'Pagamento confirmado — {{app}} liberado.',
        redirectingToPayment: 'Redirecionando para pagamento...',
        licenseRenewed: 'Sua licença foi renovada até {{date}}!',
        openPaymentTab: 'Abra a aba para concluir o pagamento.',
        // créditos de IA
        aiCreditsReversed: 'Créditos revertidos com sucesso.',
        aiCreditsRequestSent: 'Solicitação enviada. Aguarde aprovação do administrador.',
        aiCreditsRequestRejected: 'Solicitação recusada.',
        aiCreditsRequestCancelled: 'Solicitação cancelada.',
        aiCreditsRenewed: 'Créditos de IA renovados com sucesso!',
        aiCreditsAddedToAccount: 'Créditos adicionados à sua conta.',
        aiCreditsAdded: '{{credits}} créditos adicionados a {{company}}.',
        apiKeySaved: 'Chave {{label}} salva com sucesso.',
        apiKeyRemoved: 'Chave {{label}} removida.',
        markupUpdated: 'Markup atualizado.',
        modelCreated: 'Modelo cadastrado.',
        modelUpdated: 'Modelo atualizado.',
        modelDisabled: 'Modelo desativado.',
        // integrações / credenciais
        metaCredentialsSaved: 'Credenciais Facebook/Meta salvas com sucesso.',
        googleCredentialsSaved: 'Credenciais Google salvas com sucesso.',
        smtpSaved: 'Configurações SMTP salvas com sucesso.',
        openaiKeySaved: 'Chave OpenAI salva com sucesso.',
        whatsappOfficialSaved: 'Configuração WhatsApp Oficial salva com sucesso.',
        pixEfiSaved: 'Configuração Pix Efí salva com sucesso.',
        googleSheetsAuthenticated: 'Autenticado com Google Sheets!',
        integrationCreated: 'Integração criada.',
        integrationUpdated: 'Integração atualizada.',
        integrationRemoved: 'Integração removida.',
        mappingSaved: 'Mapeamento salvo.',
        baseUrlSaved: 'Copiado e URL base salva no backend!',
        // conexões / whatsapp
        whatsappConnected: 'WhatsApp conectado com sucesso!',
        // contatos / observações
        contactBlocked: 'Contato bloqueado.',
        contactUnblocked: 'Contato desbloqueado.',
        contactsImported: 'Contatos importados da conexão.',
        spreadsheetImported: 'Planilha importada.',
        noteAdded: 'Observação adicionada com sucesso!',
        noteDeleted: 'Observação excluída com sucesso!',
        clientCreated: 'Cliente criado com sucesso!',
        clientUpdated: 'Cliente atualizado com sucesso!',
        ticketValueUpdated: 'Valor do ticket atualizado!',
        queueUpdated: 'Fila atualizada!',
        allTicketsClosed: 'Todos os tickets {{status}} foram encerrados.',
        chatbotEnabled: 'Chatbot habilitado.',
        chatbotDisabled: 'Chatbot desabilitado.',
        contactActivated: 'Contato ativado com sucesso.',
        contactDeactivated: 'Contato desativado.',
        // CRM
        pipelineCreated: 'Funil criado!',
        pipelineSaved: 'Funil salvo!',
        pipelineDeleted: 'Funil excluído!',
        crmFieldCreated: 'Campo criado.',
        crmFieldUpdated: 'Campo atualizado.',
        crmFieldRemoved: 'Campo removido.',
        crmSourceCreated: 'Origem criada!',
        crmSourceRemoved: 'Origem removida.',
        automationCreated: 'Automação criada.',
        automationUpdated: 'Automação atualizada.',
        automationRemoved: 'Automação removida.',
        triggerCreated: 'Disparo criado com sucesso.',
        triggerUpdated: 'Disparo atualizado com sucesso.',
        triggerRemoved: 'Disparo removido.',
        // produtos
        productSaved: 'Produto salvo com sucesso.',
        productCreated: 'Produto criado com sucesso.',
        productUpdated: 'Produto atualizado.',
        productDeleted: 'Produto excluído.',
        variantCreated: 'Variante criada.',
        variantUpdated: 'Variante atualizada.',
        variantDeleted: 'Variante excluída.',
        variantsGenerated: 'Variações geradas.',
        categoryCreated: 'Categoria criada.',
        categoryUpdated: 'Categoria atualizada.',
        categoryDeleted: 'Categoria excluída.',
        attributeCreated: 'Atributo criado.',
        attributeUpdated: 'Atributo atualizado.',
        attributeDeleted: 'Atributo excluído.',
        optionDeleted: 'Opção excluída.',
        // profissionais / serviços
        professionalCreated: 'Profissional criado com sucesso!',
        professionalUpdated: 'Profissional atualizado com sucesso!',
        professionalRemoved: 'Profissional removido com sucesso!',
        serviceCreated: 'Serviço criado com sucesso!',
        serviceRemoved: 'Serviço removido com sucesso!',
        serviceUpdated: 'Serviço atualizado com sucesso!',
        // filas / horários
        queueHoursSet: 'Horários configurados com sucesso!',
        queueHoursUpdated: 'Horários atualizados com sucesso!',
        // frases / campanhas
        phraseCreated: 'Frase criada com sucesso!',
        phraseUpdated: 'Frase alterada com sucesso!',
        phraseDeleted: 'Frase deletada.',
        campaignDeleted: 'Campanha deletada.',
        // fluxos
        flowCreated: 'Fluxo criado com sucesso.',
        flowUpdated: 'Fluxo atualizado com sucesso.',
        flowSaved: 'Fluxo salvo com sucesso.',
        flowDeleted: 'Fluxo excluído com sucesso.',
        flowDuplicated: 'Fluxo duplicado com sucesso.',
        flowExported: 'Fluxo exportado com sucesso.',
        flowImported: 'Fluxo "{{name}}" importado com sucesso!',
        defaultFlowsUpdated: 'Fluxos padrões atualizados.',
        // follow-up
        followUpScheduled: 'Follow-up agendado.',
        followUpCancelled: 'Follow-up cancelado.',
        followUpCreated: 'Follow-up criado com sucesso.',
        followUpByTagScheduled: 'Follow-up por tag agendado.',
        followUpsByTagScheduled: '{{count}} follow-ups por tag agendados.',
        followUpsCreated: '{{count}} follow-ups criados com sucesso.',
        allTicketFollowUpsCancelled: 'Todos os follow-ups do ticket foram cancelados.',
        processingTriggered: 'Processamento acionado.',
        noResponseRuleCreated: 'Regra de tempo sem resposta criada.',
        noResponseRuleUpdated: 'Regra de tempo sem resposta atualizada.',
        recurringRuleCreated: 'Regra de follow-up recorrente criada.',
        recurringRuleUpdated: 'Regra de follow-up recorrente atualizada.',
        tagContactsRuleCreated: 'Regra por tag (contatos) criada.',
        ruleDeleted: 'Regra excluída.',
        // banners / personalização
        bannerCreated: 'Banner criado com sucesso!',
        bannerUpdated: 'Banner atualizado com sucesso!',
        bannerRemoved: 'Banner removido com sucesso!',
        colorsSaved: 'Cores de personalização salvas com sucesso.',
        themeSaved:
          'Todo o tema foi salvo: Menu, Botões e Links, Tipografia e cor primária (quando alterados).',
        emailFooterSaved: 'Configurações do rodapé de e-mail salvas com sucesso.',
        tabTitleUpdated: 'Título da aba atualizado com sucesso.',
        tabIconUpdated: 'Ícone da aba atualizado com sucesso.',
        pwaIconUpdated: 'Ícone PWA atualizado. O backend gerou os tamanhos padrão.',
        // faturas / pagamentos
        invoiceCopyGenerated: '2ª via gerada com sucesso.',
        paymentRegistered: 'Pagamento registrado com sucesso.',
        paymentRemoved: 'Pagamento removido.',
        invoiceDeleted: 'Fatura excluída com sucesso.',
        subscriptionCancelled: 'Assinatura cancelada.',
        subscriptionReactivated: 'Assinatura reativada.',
        // kanban / motivos
        kanbanCreated: 'Kanban criado com sucesso!',
        kanbanTagDeleted: 'Tag Kanban excluída com sucesso.',
        reasonSaved: 'Motivo salvo.',
        reasonCreated: 'Motivo criado!',
        reasonRemoved: 'Motivo removido.',
        // documentação / tokens / mensagens
        tokenGenerated: 'Token gerado com sucesso!',
        tokenCopied: 'Token copiado para a área de transferência!',
        tokenRemoved: 'Token removido com sucesso!',
        messageSent: 'Mensagem enviada com sucesso.',
        // notificações / IA workflow
        notificationSent: 'Notificação enviada!',
        notificationRemoved: 'Notificação removida.',
        notificationsEnabled:
          'Notificações ativadas. Você receberá avisos de novos leads e mensagens.',
        iaWorkflowDeleted: 'Workflow de IA deletado com sucesso!',
        // perfil / quick messages
        profileUpdated: 'Perfil atualizado com sucesso!',
        quickMessageDeleted: 'Resposta rápida excluída com sucesso.',
        importStarted: 'Importação iniciada.',
        queueDeleted: 'Fila excluída com sucesso.',
        emailSent: 'E-mail enviado com sucesso.',
        newCodeSent: 'Novo código enviado para o seu e-mail.',
        passwordChanged: 'Senha alterada com sucesso.',
      },
      toastInfo: {
        cepNotFound: 'CEP não encontrado.',
        noChangesToSave: 'Nenhuma alteração para salvar.',
        noColorChangesToSave: 'Nenhuma alteração de cores para salvar.',
        googleAuthWaiting: 'Ainda aguardando autenticação no Google.',
        completeAuthInWindow: 'Conclua a autenticação na janela aberta.',
        paymentNotConfirmedYet:
          'Pagamento ainda não consta como confirmado. Aguarde e tente de novo.',
        qrNotAvailableYet: 'QR Code ainda não disponível.',
        chargeRequested: 'Cobrança solicitada. Verifique suas faturas em instantes.',
        notificationsDisabled: 'Notificações desativadas.',
        preparingFlowExport: 'Preparando exportação do fluxo...',
        importingFlow: 'Importando fluxo, por favor aguarde...',
        addAtLeastOneMapping: 'Adicione ao menos um mapeamento.',
        couldNotVerifyConnections: 'Não foi possível verificar as conexões. Tente novamente.',
        themeApplied:
          'Tema aplicado ao rascunho (incluindo a cor primária). Use «Salvar todo o tema» acima ou salve cada seção abaixo para gravar no servidor.',
      },
      toastWarning: {
        invalidCreditValue: 'Informe um valor válido de créditos.',
        apiKeyRequired: 'Informe a chave da API {{label}}.',
        modelIdRequired: 'Informe o identificador do modelo.',
        providerRequired: 'Selecione o provedor.',
        modelPricesRequired: 'Informe os preços de input e output (USD por 1M tokens).',
        defaultPlanCannotEdit: 'Este plano é padrão do sistema e não pode ser alterado.',
        defaultPlanCannotDelete: 'Este plano é padrão do sistema e não pode ser excluído.',
        configureAtLeastOneField: 'Configure ao menos um campo para atualizar.',
        nameMinLength: 'Informe um nome com pelo menos 2 caracteres.',
        automationNameRequired: 'Informe um nome para a automação.',
        statusRequired: 'Selecione o status.',
        addAtLeastOneAction: 'Adicione ao menos uma ação.',
        categoryNameRequired: 'Informe o nome da categoria.',
        optionNameRequired: 'Preencha o nome da opção.',
        abbreviationRequired: 'Preencha a sigla.',
        attributeNameRequired: 'Informe o nome do atributo.',
        productNameRequired: 'Preencha o nome do produto.',
        productNameRequiredToContinue: 'Preencha o nome do produto para continuar.',
        invoiceCopyFailed: 'Não foi possível gerar a 2ª via.',
        chargeFailed: 'Não foi possível gerar a cobrança.',
      },
      apiDocs: {
        clientsLoaded: 'Clientes carregados!',
        clientLoaded: 'Cliente carregado!',
        clientCreated: 'Cliente criado com sucesso!',
        clientUpdated: 'Cliente atualizado com sucesso!',
        clientRemoved: 'Cliente removido!',
        queuesLoaded: 'Filas carregadas!',
        queueLoaded: 'Fila carregada!',
        queueCreated: 'Fila criada com sucesso!',
        queueUpdated: 'Fila atualizada com sucesso!',
        queueRemoved: 'Fila removida!',
        connectionsLoaded: 'Conexões carregadas!',
        connectionLoaded: 'Conexão carregada!',
        statusLoaded: 'Status carregado!',
        connectionUpdated: 'Conexão atualizada!',
        connectionRestarting: 'Conexão reiniciando!',
        connectionDisconnected: 'Conexão desconectada!',
        connectionCreated: 'Conexão criada! Aguarde o QR Code.',
        qrAvailable: 'QR Code disponível!',
        connectionRemoved: 'Conexão removida!',
        servicesLoaded: 'Serviços carregados!',
        serviceLoaded: 'Serviço carregado!',
        serviceRemoved: 'Serviço removido!',
        tagsLoaded: 'Tags carregadas!',
        tagLoaded: 'Tag carregada!',
        tagCreated: 'Tag criada com sucesso!',
        tagUpdated: 'Tag atualizada com sucesso!',
        tagRemoved: 'Tag removida!',
        tasksLoaded: 'Tarefas carregadas!',
        taskLoaded: 'Tarefa carregada!',
        taskCreated: 'Tarefa criada com sucesso!',
        taskUpdated: 'Tarefa atualizada com sucesso!',
        taskRemoved: 'Tarefa removida!',
        contactsLoaded: 'Contatos carregados!',
        contactLoaded: 'Contato carregado!',
        contactCreated: 'Contato criado com sucesso!',
        contactUpdated: 'Contato atualizado com sucesso!',
        contactRemoved: 'Contato removido!',
        invoicesLoaded: 'Faturas carregadas!',
        invoiceLoaded: 'Fatura carregada!',
        invoiceCreated: 'Fatura criada!',
        invoiceUpdated: 'Fatura atualizada!',
        invoicePaid: 'Fatura marcada como paga!',
        invoiceCancelled: 'Fatura cancelada!',
        invoiceRemoved: 'Fatura removida!',
        dealsLoaded: 'Negócios carregados!',
        dealLoaded: 'Negócio carregado!',
        dealCreated: 'Negócio criado com sucesso!',
        dealUpdated: 'Negócio atualizado com sucesso!',
        dealRemoved: 'Negócio removido!',
        productsLoaded: 'Produtos carregados!',
        productLoaded: 'Produto carregado!',
        productCreated: 'Produto criado com sucesso!',
        productUpdated: 'Produto atualizado com sucesso!',
        productRemoved: 'Produto removido!',
        usersLoaded: 'Usuários carregados!',
        userLoaded: 'Usuário carregado!',
        userCreated: 'Usuário criado com sucesso!',
        userUpdated: 'Usuário atualizado com sucesso!',
        userRemoved: 'Usuário removido!',
        servicesUpdated: 'Serviços atualizados!',
        scheduleLoaded: 'Agenda carregada!',
        scheduleCreated: 'Agenda criada!',
        appointmentsLoaded: 'Compromissos carregados!',
        appointmentCreated: 'Compromisso criado!',
        statusUpdated: 'Status atualizado!',
        tagsKanbanLoaded: 'Tags kanban carregadas!',
        tagKanbanLoaded: 'Tag kanban carregada!',
        tagKanbanCreated: 'Tag kanban criada com sucesso!',
        tagKanbanUpdated: 'Tag kanban atualizada com sucesso!',
        tagKanbanRemoved: 'Tag kanban removida!',
        ticketsLoaded: 'Tickets carregados!',
        ticketLoaded: 'Ticket carregado!',
        messagesLoaded: 'Mensagens carregadas!',
        ticketUpdated: 'Ticket atualizado!',
        ticketClosed: 'Ticket fechado!',
        ticketReopened: 'Ticket reaberto!',
        ticketTransferred: 'Ticket transferido!',
      },
      backendErrorTokens: {
        ACCESS: 'acesso',
        ACTIVE: 'ativo',
        ANNOUNCEMENT: 'anúncio',
        API: 'API',
        APP: 'aplicativo',
        APPOINTMENT: 'agendamento',
        AUTH: 'autenticação',
        AUTOMATION: 'automação',
        BRL: 'BRL',
        CAMPAIGN: 'campanha',
        CHAT: 'chat',
        CHATBOT: 'chatbot',
        CLIENT: 'cliente',
        CODE: 'código',
        COMPANY: 'empresa',
        CONFIGURED: 'configurado',
        CONNECTION: 'conexão',
        CONTACT: 'contato',
        CREDENTIALS: 'credenciais',
        CREATION: 'criação',
        DELETE: 'exclusão',
        DISABLED: 'desabilitado',
        DUPLICATED: 'duplicado',
        EMAIL: 'e-mail',
        EXPIRED: 'expirado',
        EXTERNAL: 'externa',
        FACEBOOK: 'Facebook',
        FATURA: 'fatura',
        FETCH: 'busca',
        FORBIDDEN: 'proibido',
        FOUND: 'encontrado',
        INACTIVE: 'inativo',
        INTEGRATIONS: 'integrações',
        INTERNAL: 'interno',
        INVALID: 'inválido',
        MEDIA: 'mídia',
        MESSAGE: 'mensagem',
        MISSING: 'ausente',
        NAME: 'nome',
        NO: 'nenhum',
        NOT: 'não',
        OPENAI: 'OpenAI',
        PASSWORD: 'senha',
        PERMISSION: 'permissão',
        PLAN: 'plano',
        PROJECT: 'projeto',
        QUEUE: 'fila',
        REQUIRED: 'obrigatório',
        ROUTE: 'rota',
        SENDING: 'envio',
        SERVICE: 'serviço',
        SESSION: 'sessão',
        SUBSCRIPTION: 'assinatura',
        TAG: 'tag',
        TASK: 'tarefa',
        TICKET: 'ticket',
        TOKEN: 'token',
        USER: 'usuário',
        VALIDATION: 'validação',
        VALUE: 'valor',
        WAPP: 'WhatsApp',
        WHATSAPP: 'WhatsApp',
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: 'Deve haver pelo menos um WhatsApp padrão.',
        ERR_NO_DEF_WAPP_FOUND: 'Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.',
        ERR_WAPP_NOT_INITIALIZED:
          'Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.',
        ERR_WAPP_CHECK_CONTACT:
          'Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões',
        ERR_WAPP_INVALID_CONTACT: 'Este não é um número de Whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA:
          'Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.',
        ERR_INVALID_CREDENTIALS: 'Erro de autenticação. Por favor, tente novamente.',
        ERR_INVALID_TOKEN: 'Token inválido. Faça login novamente.',
        ERR_SENDING_WAPP_MSG:
          'Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.',
        ERR_SENDING_FACEBOOK_MSG:
          'Erro ao enviar mensagem pelo Facebook/Instagram. Verifique a conexão.',
        instagram_does_not_support_this_media_type:
          'O Instagram não suporta este tipo de arquivo. Envie apenas imagens JPEG, PNG, GIF ou WEBP.',
        ERR_DELETE_WAPP_MSG: 'Não foi possível excluir a mensagem do WhatsApp.',
        ERR_OTHER_OPEN_TICKET: 'Já existe um tíquete aberto para este contato.',
        ERR_SESSION_EXPIRED: 'Sessão expirada. Por favor entre.',
        ERR_HEADER_OR_COOKIE_TOO_LARGE:
          'Cookies/cabeçalho do navegador muito grandes. Use o modal de limpeza ou limpe os cookies do site da API.',
        ERR_NO_AUTH_TOKEN: 'Requisição sem token de autorização. Faça login novamente.',
        ERR_ACCESS_TOKEN_EXPIRED: 'Token de acesso expirado. Atualize a página ou faça login.',
        ERR_REFRESH_TOKEN_MISSING: 'Refresh token ausente. Faça login novamente.',
        ERR_REFRESH_TOKEN_EXPIRED: 'Refresh token expirado. Faça login novamente.',
        ERR_REFRESH_TOKEN_INVALID: 'Refresh token inválido. Faça login novamente.',
        ERR_SESSION_REVOKED:
          'Sessão invalidada (ex.: logout em outro dispositivo). Faça login novamente.',
        ERR_AUTH_REQUIRED: 'Autenticação necessária. Faça login para continuar.',
        ERR_APP_NOT_ACTIVE:
          'O aplicativo ou integração não está ativo. Verifique nas configurações ou com o suporte.',
        ERR_PLAN_INTERNAL_CHAT_DISABLED:
          'O chat interno não está disponível no plano atual da empresa.',
        ERR_PLAN_INTEGRATIONS_DISABLED:
          'Integrações não estão disponíveis no plano atual da empresa.',
        ERR_COMPANY_APP_ALREADY_CANCELLED: 'Este app já foi desativado anteriormente.',
        ERR_COMPANY_TOKEN_MISSING: 'Token da empresa não informado.',
        ERR_COMPANY_TOKEN_NOT_CONFIGURED: 'Token da empresa não configurado no servidor.',
        ERR_COMPANY_TOKEN_INVALID: 'Token da empresa inválido.',
        ERR_API_TOKEN_MISSING: 'Token da API não informado.',
        ERR_API_TOKEN_NOT_CONFIGURED: 'Integração sem token configurado.',
        ERR_API_TOKEN_INVALID: 'Token da API inválido.',
        ERR_USER_CREATION_DISABLED: 'A criação do usuário foi desabilitada pelo administrador.',
        ERR_NO_PERMISSION: 'Você não tem permissão para acessar este recurso.',
        ERR_DUPLICATED_CONTACT: 'Já existe um contato com este número.',
        ERR_CRM_INSUFFICIENT_STOCK:
          'Estoque insuficiente para um ou mais produtos da oportunidade. A venda não foi marcada como ganha.',
        ERR_CRM_OPPORTUNITY_NOT_FOUND: 'Oportunidade não encontrada.',
        ERR_CRM_OPPORTUNITY_LOCKED: 'Esta oportunidade está fechada e não pode ser editada.',
        ERR_CRM_LOSS_REASON_REQUIRED: 'Informe o motivo da perda antes de concluir.',
        ERR_CRM_PRODUCT_NOT_FOUND: 'Produto da oportunidade não encontrado.',
        ERR_NO_SETTING_FOUND: 'Nenhuma configuração encontrada com este ID.',
        ERR_NO_CONTACT_FOUND: 'Nenhum contato encontrado com este ID.',
        ERR_NO_TICKET_FOUND: 'Nenhum tíquete encontrado com este ID.',
        ERR_NO_USER_FOUND: 'Nenhum usuário encontrado com este ID.',
        ERR_NO_WAPP_FOUND: 'Nenhum WhatsApp encontrado com este ID.',
        ERR_CREATING_MESSAGE: 'Erro ao criar mensagem no banco de dados.',
        ERR_CREATING_TICKET: 'Erro ao criar tíquete no banco de dados.',
        ERR_FETCH_WAPP_MSG: 'Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS: 'Esta cor já está em uso, escolha outra.',
        ERR_QUEUE_NOT_FOUND: 'Fila não encontrada. Atualize a página e tente novamente.',
        ERR_WAPP_GREETING_REQUIRED:
          'A mensagem de saudação é obrigatório quando há mais de uma fila.',
        ERR_OUT_OF_HOURS: 'Fora do Horário de Expediente!',
        ERR_EMAIL_ALREADY_EXISTS: 'Este e-mail já está em uso.',
        ERR_COMPANY_NAME_ALREADY_EXISTS: 'Este nome de empresa já está cadastrado.',
        ERR_COMPANY_DOCUMENT_ALREADY_EXISTS: 'Este CPF/CNPJ já está cadastrado.',
        ERR_UNIQUE_CONSTRAINT_VIOLATION:
          'Já existe um registro com esse valor. Verifique os campos e tente novamente.',
        ERR_META_IMPORT_TOKEN_MISSING:
          'Conecte a página em Configurações > Conexões antes de importar.',
        ERR_META_IMPORT_PAGE_NOT_FOUND:
          'Nenhuma conexão encontrada para pageId. Vincule a página em Configurações > Conexões.',
        ERR_ROUTE_NOT_FOUND:
          'Rota ou recurso não encontrado. Verifique o endereço ou tente novamente.',
        ERR_CREATING_FOLLOW_UP:
          'Não foi possível criar o follow-up. Verifique os dados e tente novamente.',
        ERR_PASSWORD_RESET_CODE_INVALID:
          'Código inválido ou expirado. Verifique o código ou solicite um novo.',
        ERR_PROMPT_INTELLIGENCE_INVALID:
          'A configuração de inteligência deste prompt é inválida. Revise modelo, ferramentas e campos obrigatórios.',
        missing_code_or_state: 'Autorização cancelada ou expirada. Tente novamente.',
        invalid_or_expired_state: 'Sessão de autorização expirada. Inicie o processo novamente.',
        no_pages_found:
          'Sua conta não gerencia nenhuma Facebook Page. Para usar o chat do Messenger ou Instagram, você precisa ser administrador de uma Page no Facebook.',
        subscribe_failed:
          'Página conectada, mas o webhook não foi ativado. Verifique se o app está em modo Live.',
        token_exchange_failed: 'Erro ao autenticar a página. Tente reconectar.',
        conflict: 'Esta página já está em uso por outra conta. Desconecte-a antes de continuar.',
        ERR_CHAT_MESSAGE_DELETE_FORBIDDEN: 'Só quem enviou a mensagem pode excluí-la.',
        ERR_REACTIONS_WHATSAPP_ONLY: 'Reações só estão disponíveis em conversas WhatsApp.',
        ERR_REACTIONS_INVALID_TARGET: 'Não é possível reagir a este tipo de mensagem.',
        ERR_REACTIONS_NOT_AVAILABLE_PRIVATE: 'Não é possível reagir a mensagens privadas.',
        ERR_MESSAGE_KEY_UNAVAILABLE:
          'Não foi possível reagir: dados da mensagem no WhatsApp não estão disponíveis.',
        ERR_SENDING_WAPP_REACTION:
          'Erro ao enviar a reação pelo WhatsApp. Verifique a sessão e tente novamente.',
        ERR_WAPP_NOT_CONNECTED: 'WhatsApp não está conectado. Verifique a página de conexões.',
        ERR_CLIENT_REACTION_INVALID_MESSAGE_ID:
          'Aguarde a mensagem ser salva no servidor antes de reagir.',
        ERR_LUNCH_MIN_ONE_HOUR: 'O intervalo de almoço deve ter no mínimo 1 hora.',
        ERR_ROLE_NOT_FOUND: 'Perfil de acesso não encontrado.',
        ERR_ROLE_HAS_USERS: 'Não é possível excluir: há usuários vinculados a este perfil.',
        ERR_ROLE_DEFAULT_CANNOT_BE_DELETED: 'Perfis padrão do sistema não podem ser excluídos.',
        ERR_ROLE_DEFAULT_CANNOT_BE_EDITED: 'Perfis padrão do sistema não podem ser editados.',
        ERR_ROLE_NAME_ALREADY_EXISTS: 'Já existe um perfil com este nome.',
        ERR_ROLE_INVALID_NAME: 'O nome do perfil deve ter pelo menos 2 caracteres.',
      },
      roles: {
        title: 'Perfis de Acesso',
        subtitle: 'Gerencie os perfis e permissões dos usuários da empresa',
        table: {
          name: 'Nome',
          description: 'Descrição',
          permissions: 'Permissões',
          users: 'Usuários',
          actions: 'Ações',
          default: 'Padrão',
        },
        buttons: {
          add: 'Novo Perfil',
          edit: 'Editar',
          view: 'Visualizar',
          delete: 'Excluir',
        },
        confirmDelete: {
          title: 'Excluir perfil',
          message: 'Deseja excluir o perfil "{{name}}"? Esta ação não pode ser desfeita.',
        },
        toasts: {
          deleted: 'Perfil excluído com sucesso.',
          created: 'Perfil criado com sucesso.',
          updated: 'Perfil atualizado com sucesso.',
        },
      },
      roleForm: {
        subtitle: 'Defina nome, descrição e selecione as permissões do perfil de acesso.',
        nameRequired: 'Nome do perfil é obrigatório.',
      },
      userPermissionsTab: {
        adminInfo:
          'Usuários com perfil Admin têm acesso total a todas as funcionalidades. Nenhuma configuração de permissões é necessária.',
        adminProfileHint:
          'Este usuário tem perfil Administrador. As permissões abaixo já valem para ele — apenas o proprietário da conta tem acesso total irrestrito. Use-as para restringir, por exemplo, quais tickets e conexões ele enxerga.',
        roleSection: {
          title: 'Perfil de Acesso',
          label: 'Perfil de acesso',
          noRole: 'Sem perfil (acesso mínimo)',
          default: 'padrão',
        },
        permissionsSection: {
          title: 'Permissões do usuário',
          hint: 'Ao escolher um perfil, as permissões dele já vêm marcadas. Ajuste os checks para personalizar este usuário.',
        },
      },
      roleModal: {
        title: {
          add: 'Novo Perfil de Acesso',
          edit: 'Editar Perfil de Acesso',
        },
        form: {
          name: 'Nome do perfil',
          description: 'Descrição (opcional)',
          permissions: 'Permissões',
          searchPermissions: 'Buscar permissão...',
          selectAll: 'Selecionar todos',
          deselectAll: 'Desmarcar todos',
        },
        buttons: {
          cancel: 'Cancelar',
          save: 'Salvar',
        },
        modules: {
          tickets: 'Tickets',
          contacts: 'Contatos',
          queues: 'Filas',
          connections: 'Conexões',
          dashboard: 'Dashboard',
          reports: 'Relatórios',
          users: 'Usuários',
          roles: 'Perfis de Acesso',
          chat: 'Chat Interno',
          quick_messages: 'Respostas Rápidas',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          tags: 'Tags',
          settings: 'Configurações',
          realtime: 'Tempo Real',
          crm: 'CRM',
          clients: 'Clientes',
          tasks: 'Tarefas',
          projects: 'Projetos/Tarefas',
          integrations: 'Integrações',
          flows: 'Fluxos',
          flowbuilder: 'Flow Builder',
          automations: 'Automações',
          followup: 'Follow-up',
          no_response: 'Tempo sem resposta',
          ia: 'IA / Workflows',
          services: 'Serviços',
          products: 'Produtos',
          financial: 'Financeiro',
          mass_dispatch: 'Disparo em massa',
          api: 'API',
        },
      },
    },
  },
};

export { messages };
